/** Supplemental Marathi strings (merged into main translations). */
export default {
  nav: {
    home: 'मुख्यपृष्ठ',
    brandName: 'गडकोट',
    explore: 'शोध',
    exploreGallery: 'महाराष्ट्र वारसा दालन',
    exploreGalleryDesc: 'गड, देवस्थाने, इतिहास आणि शस्त्रवैभव',
    tools: 'साधने',
    toolsGallery: 'स्वराज्य ज्ञानदालन',
    toolsGalleryDesc: 'प्रवास, इतिहास, शिक्षण आणि लोकसहभाग',
    toolsGalleryFooter: 'गडकोट • ज्ञान • प्रवास • संवर्धन',
    organizationsGallery: 'वारसा संस्था व मंडळे',
    organizationsGalleryDesc: 'संवर्धन, संशोधन, संस्कृती आणि सेवा',
    organizationsGalleryFooter: 'एकजूट • सेवा • संस्कृती • संवर्धन',
    search: 'शोधा',
    tagline: 'वारसा शोधा',
    fortsDesc: 'ऐतिहासिक गड',
    nearbyForts: 'जवळचे गड',
    nearbyFortsDesc: 'तुमच्या स्थानापासून खरी अंतरे',
    templesDesc: 'पवित्र मंदिरे',
    trekPlanner: 'ट्रेक नियोजक',
    trekPlannerDesc: 'आपला प्रवास नियोजित करा',
    emergency: 'आपत्कालीन व बचाव',
    emergencyDesc: 'हॉटलाइन, बचाव संघ, गड ट्रेक आपत्काल',
    contributions: 'योगदान',
    contributionsDesc: 'अनुभव सामायिक करा',
    fortGuide: 'AI गड मार्गदर्शक',
    fortGuideDesc: 'कोणत्याही गडाबद्दल मराठी/इंग्रजीत विचारा',
    community: 'समुदाय',
    communityDesc: 'निर्माते, बक्षिसे, referral व अलर्ट',
    quiz: 'प्रश्नमंजुषा',
    quizDesc: 'आपले ज्ञान तपासा',
    shortNotes: 'थोडक्यात नोंदी',
    shortNotesDesc: 'अभ्यास साहित्य',
    learn: 'शिका',
    learnDesc: 'शैक्षणिक सामग्री',
    institutionPortal: 'शाळा व महाविद्यालये',
    institutionPortalDesc: 'गटभेटी आणि कार्यपत्रिका',
    audiobooks: 'मराठी ऑडिओबुक',
    audiobooksDesc: 'गडकथा आणि दंतकथा',
    badges: 'बॅज',
    badgesDesc: 'उपलब्धी प्रणाली',
    blogDesc: 'कथा आणि लेख',
    wades: 'वाडे',
    wadesDesc: 'ऐतिहासिक वाडे आणि हवेली',
    history: 'इतिहास',
    historyDesc: 'ऐतिहासिक माहिती आणि कालखंड',
    books: 'वारसा पुस्तके',
    booksDesc: 'गड इतिहास, मार्गदर्शिका आणि भक्ती PDF ऑनलाइन वाचा',
    heritage: 'वारसा केंद्र',
    heritageDesc: 'भक्त गडकोट, सरदार, ठिकाण, भागीदार',
    heritageGallery: 'वारसा चित्रगॅलरी',
    heritageGalleryDesc: 'गड, मंदिर, वाडे, शस्त्रे आणि समुदायाचे फोटो',
    wishlist: 'इच्छासूची',
    visitPlanner: 'भेट नियोजक',
    signIn: 'साइन इन',
    account: 'खाते',
    accountMenuHint: 'साइन इन करा किंवा वारसा प्रोफाइल तयार करा',
    adminSection: 'प्रशासन',
    adminDashboard: 'प्रशासक डॅशबोर्ड',
    uploadManage: 'अपलोड आणि व्यवस्थापन',
    manageOrganization: 'माझी संस्था व्यवस्थापित करा',
    organizationSection: 'संस्था',
    geographicExplorer: 'भौगोलिक शोध',
    thematicRoutes: 'विषयक मार्ग',
    organizations: 'संस्था व मंडळे',
    events: 'कार्यक्रम दिनदर्शिका',
    eventsDesc: 'गड उत्सव, जत्रा, ट्रेक आणि वारसा पायऱ्या',
    shop: 'वारसा दुकान',
    shopDesc: 'पुस्तके, ट्रेक साहित्य, डिजिटल मार्गदर्शक आणि मर्च',
    weapons: 'शस्त्रे व माहिती',
    weaponsDesc: 'मराठा कालखंडातील ऐतिहासिक शस्त्रे',
    organizationCategories: {
      fortConservation: 'गडसंवर्धन संस्था',
      fortEnthusiastGroups: 'दुर्गप्रेमी संघटना',
      trekkingGroups: 'ट्रेकिंग गट',
      historyStudyCircles: 'इतिहास अभ्यासक मंडळे',
      historyResearchInstitutes: 'इतिहास संशोधन संस्था',
      socialOrganizations: 'सामाजिक संस्था',
      environmentalConservation: 'पर्यावरण संवर्धन संस्था',
      shivjayantiFestivalCommittees: 'शिवजयंती उत्सव मंडळे',
      ganeshFestivalCommittees: 'गणेशोत्सव मंडळे',
      culturalGroups: 'सांस्कृतिक मंडळे',
      rescueGroups: 'आपत्ती व्यवस्थापन / बचाव गट',
    },
  },
  organizations: {
    seoDescription: 'गडसंवर्धन, ट्रेकिंग, इतिहास आणि सांस्कृतिक संस्था व मंडळे.',
    subtitle: 'महाराष्ट्रातील गड, इतिहास आणि वारशाशी संबंधित संस्था व मंडळे.',
    loadError: 'संस्थांची माहिती लोड होऊ शकली नाही.',
    loading: 'लोड होत आहे…',
    noResults: 'या श्रेणीत अद्याप कोणतीही संस्था नोंदवलेली नाही.',
    searchPlaceholder: 'संस्था किंवा ठिकाण शोधा…',
    districtFilter: 'जिल्हा',
    resultsCount: '{{count}} संस्था सापडल्या',
    viewDetails: 'तपशील पहा',
    backToHub: 'संस्था व मंडळे',
    backToCategory: 'श्रेणीवर परत',
    about: 'माहिती',
    overview: 'संक्षिप्त माहिती',
    history: 'इतिहास व पार्श्वभूमी',
    activities: 'उपक्रम व कार्यक्षेत्र',
    team: 'कार्यकारिणी',
    pageSections: 'पृष्ठ विभाग',
    eventsSubtitle: 'आगामी आणि वार्षिक कार्यक्रम',
    viewEventsCalendar: 'संपूर्ण कार्यक्रम दिनदर्शिका',
    noGallery: 'अद्याप चित्रे उपलब्ध नाहीत.',
    noEvents: 'अद्याप कार्यक्रम नोंदवलेले नाहीत.',
    contact: 'संपर्क',
    gallery: 'चित्रगॅलरी',
    events: 'कार्यक्रम',
    members: 'सदस्य',
    documents: 'कागदपत्रे',
    socialLinks: 'सोशल मीडिया',
    typeDetails: 'विशेष माहिती',
    established: 'स्थापना',
    registration: 'नोंदणी क्र.',
    rescueHotlineTitle: '२४×७ आपत्कालीन संपर्क',
    rescueHotlineDesc: 'बचाव / आपत्ती व्यवस्थापन संघाला थेट कॉल करा.',
    yes: 'होय',
    no: 'नाही',
    fields: {
      fortsConserved: 'संवर्धित गड',
      conservationProjectsCount: 'संवर्धन प्रकल्प',
      membershipCount: 'सदस्य संख्या',
      affiliatedForts: 'संलग्न गड',
      focusArea: 'कार्यक्षेत्र',
      beneficiariesCount: 'लाभार्थी संख्या',
      registrationType: 'नोंदणी प्रकार',
      ganpatiName: 'गणपतीचे नाव',
      mandalEstablishedYear: 'मंडळ स्थापना वर्ष',
      idolHeightFt: 'मूर्ती उंची (फूट)',
      annualBudget: 'वार्षिक अंदाजपत्रक',
      wardName: 'प्रभाग',
      celebrationDate: 'उत्सव तारीख',
      annualPrograms: 'वार्षिक कार्यक्रम',
      affiliatedVillages: 'संलग्न गावे',
      trekFrequency: 'ट्रेक वारंवारिता',
      difficultyLevel: 'अडचण पातळी',
      maxGroupSize: 'कमाल गट आकार',
      equipmentProvided: 'उपकरणे',
      fortsCovered: 'समाविष्ट गड',
      annualFortVisits: 'वार्षिक गड भेटी',
      membershipType: 'सदस्यत्व प्रकार',
      researchFocus: 'संशोधन क्षेत्र',
      publicationsCount: 'प्रकाशने',
      libraryAvailable: 'ग्रंथालय',
      environmentalFocus: 'पर्यावरण कार्य',
      projectsCount: 'प्रकल्प संख्या',
      treePlantationCount: 'वृक्षारोपण',
      culturalActivities: 'सांस्कृतिक उपक्रम',
      artForms: 'कला प्रकार',
      annualEventsCount: 'वार्षिक कार्यक्रम',
      rescueSpecialization: 'बचाव विशेषता',
      teamSize: 'संघ आकार',
      equipmentList: 'उपकरण यादी',
      emergencyContact24x7: 'आपत्कालीन संपर्क',
    },
  },
  share: {
    whatsapp: 'WhatsApp',
    whatsappLabel: 'WhatsApp वर शेअर करा',
    fortMessage: '{{name}} — Gadkot वर गड आणि वारसा पहा',
    eventMessage: '{{title}} — Gadkot कार्यक्रम',
    eventsMessage: 'उत्सव, जत्रा आणि कार्यक्रम — Gadkot दिनदर्शिका',
    thematicRouteMessage: '{{name}} — Gadkot विषयक मार्ग',
    organizationMessage: '{{name}} — Gadkot संस्था',
  },
  events: {
    seoTitle: 'उत्सव आणि कार्यक्रम दिनदर्शिका — गडकोट',
    seoDescription: 'गड उत्सव, जत्रा, ट्रेक आणि वारसा पायऱ्या — महाराष्ट्रभर संस्थांचे कार्यक्रम.',
    badge: 'उत्सव · जत्रा · ट्रेक · वारसा',
    title: 'उत्सव आणि कार्यक्रम दिनदर्शिका',
    subtitle: 'गड उत्सव, जत्रा, गट ट्रेक आणि वारसा पायऱ्या — संस्थांकडून नोंदवलेले कार्यक्रम.',
    tithiCalendarLink: 'तिथी इतिहास दिनदर्शिका',
    viewCalendar: 'महिना दृश्य',
    viewList: 'यादी दृश्य',
    searchPlaceholder: 'कार्यक्रम, ठिकाण, संस्था शोधा…',
    districtFilter: 'जिल्हा',
    typeFilter: 'प्रकार',
    allCategories: 'सर्व श्रेणी',
    loading: 'कार्यक्रम लोड होत आहेत…',
    loadError: 'कार्यक्रम लोड करता आले नाहीत.',
    resultsCount: '{{count}} कार्यक्रम',
    filteredLocally: 'प्रकारानुसार गाळले',
    noEvents: 'या कालावधीत कार्यक्रम नाहीत',
    noEventsHint: 'दुसरा महिना निवडा, फिल्टर काढा किंवा संस्था पहा.',
    viewOrganizer: 'आयोजक पहा',
    prevMonth: 'मागील महिना',
    nextMonth: 'पुढील महिना',
    selectedDay: 'कार्यक्रम दाखवत आहे',
    clearDay: 'सर्व दिवस',
    footerNote: 'कार्यक्रम नोंदणीकृत संस्थांकडून. तारीख व तपशील — प्रवासापूर्वी आयोजकाकडून तपासा.',
    cta: 'कार्यक्रम पहा',
    submit: {
      cta: 'कार्यक्रम नोंदवा',
      title: 'उत्सव, ट्रेक किंवा वारसा कार्यक्रम नोंदवा',
      subtitle: 'प्रशासक मंजुरीनंतरच सार्वजनिक दिनदर्शिकेत दिसेल.',
      organization: 'संस्था / मंडळ',
      selectOrganization: 'संस्था निवडा…',
      eventTitle: 'कार्यक्रमाचे नाव',
      eventTitlePlaceholder: 'उदा. सिंहगड शिव जयंती उत्सव',
      eventDate: 'कार्यक्रमाची तारीख',
      location: 'स्थान',
      locationPlaceholder: 'गड, गाव किंवा पत्ता',
      description: 'वर्णन',
      yourName: 'आपले नाव',
      email: 'ईमेल',
      phone: 'फोन',
      send: 'मंजुरीसाठी पाठवा',
      close: 'बंद करा',
      requiredError: 'संस्था, शीर्षक, तारीख आणि नाव भरा.',
      error: 'कार्यक्रम सादर करता आला नाही.',
      orgsLoadError: 'संस्था लोड होऊ शकल्या नाहीत. पृष्ठ रिफ्रेश करा.',
      noOrganizations: 'प्रकाशित संस्था अद्याप नाहीत. मंडळ प्रशासकाने संस्था प्रकाशित करावी, किंवा /organizations पहा.',
      successTitle: 'यशस्वीरित्या सादर केले',
      successMessage: 'धन्यवाद! प्रशासक तपासणी करेल. मंजुरीनंतर दिनदर्शिकेत दिसेल.',
    },
    types: {
      all: 'सर्व',
      festival: 'उत्सव',
      jatra: 'जत्रा / यात्रा',
      trek: 'ट्रेक / गड भेट',
      heritageWalk: 'वारसा पायऱ्या',
      program: 'कार्यक्रम',
    },
  },
  adminEvents: {
    title: 'कार्यक्रम मंजुरी',
    subtitle: '/events वर दिसण्यापूर्वी सार्वजनिक सादर तपासा.',
    nonePending: 'प्रलंबित कार्यक्रम नाहीत.',
    approve: 'मंजूर',
    reject: 'नाकार',
    confirmReject: 'नकार निश्चित करा',
    rejectNotePlaceholder: 'नकारासाठी टिप्पणी (ऐच्छिक)',
    submittedBy: 'सादर केले',
    unknownOrg: 'अज्ञात संस्था',
    loadError: 'प्रलंबित कार्यक्रम लोड होऊ शकले नाहीत.',
    approveError: 'मंजूर करता आले नाही.',
    rejectError: 'नकार देता आला नाही.',
  },
  adminThematicRoutes: {
    title: 'विषयक मार्ग',
    subtitle: '/thematic-routes वर दिसणारे वारसा प्रवास मार्ग व्यवस्थापित करा.',
    add: 'मार्ग जोडा',
    refresh: 'रिफ्रेश',
    searchPlaceholder: 'मार्ग शोधा…',
    none: 'अद्याप विषयक मार्ग नाहीत.',
    colName: 'नाव',
    colSlug: 'स्लग',
    colDuration: 'कालावधी',
    colStops: 'थांबे',
    colStatus: 'स्थिती',
    createTitle: 'नवीन विषयक मार्ग',
    editTitle: 'मार्ग संपादित करा',
    slug: 'URL स्लग',
    name: 'मार्गाचे नाव',
    description: 'वर्णन',
    duration: 'कालावधी',
    durationFilter: 'कालावधी फिल्टर',
    difficulty: 'अडचण',
    bestTime: 'सर्वोत्तम वेळ',
    icon: 'चिन्ह',
    status: 'स्थिती',
    image: 'मुख्य प्रतिमा URL',
    highlights: 'ठळक मुद्दे (प्रति ओळ एक)',
    experiences: 'अनुभव (प्रति ओळ एक)',
    stops: 'मार्गावरील थांबे',
    addStop: 'थांबा जोडा',
    removeStop: 'काढा',
    save: 'जतन करा',
    saving: 'जतन होत आहे…',
    cancel: 'रद्द',
    requiredError: 'स्लग आणि नाव आवश्यक.',
    loadError: 'विषयक मार्ग लोड होऊ शकले नाहीत.',
    saveError: 'जतन करता आले नाही.',
    deleteError: 'हटवता आले नाही.',
    deleteConfirm: '"{{name}}" हटवायचे?',
  },
  auth: {
    welcomeBack: 'पुन्हा स्वागत आहे',
    createAccount: 'आपले खाते तयार करा',
    email: 'ईमेल',
    password: 'पासवर्ड',
    name: 'पूर्ण नाव',
    confirmPassword: 'पासवर्ड पुष्टी करा',
    signIn: 'साइन इन',
    signUp: 'नोंदणी',
    signingIn: 'साइन इन होत आहे…',
    creatingAccount: 'खाते तयार होत आहे…',
    noAccount: 'खाते नाही?',
    haveAccount: 'आधीच खाते आहे?',
    registerLink: 'नोंदणी करा',
    loginLink: 'साइन इन करा',
    registerMenuDesc: 'नवीन सदस्य — ट्रेक, गड व वारसा तपशील जोडा',
    signInMenuDesc: 'आधीपासून खाते असेल तर',
    modalBadge: 'गडकोट वारसा मंच',
    signInSubtitle: 'गड, ट्रेक आणि वारसा प्रवास जतन करण्यासाठी साइन इन करा.',
    showPassword: 'पासवर्ड दाखवा',
    hidePassword: 'पासवर्ड लपवा',
    emailRequired: 'ईमेल आवश्यक आहे',
    emailInvalid: 'कृपया वैध ईमेल पत्ता प्रविष्ट करा',
    passwordRequired: 'पासवर्ड आवश्यक आहे',
    passwordMinLength: 'पासवर्ड किमान ८ अक्षरांचा असावा',
    nameRequired: 'नाव आवश्यक आहे',
    passwordsMismatch: 'पासवर्ड जुळत नाहीत',
    generalError: 'काहीतरी चुकले. कृपया पुन्हा प्रयत्न करा.',
    pleaseWait: 'कृपया प्रतीक्षा करा…',
    createAccountBtn: 'खाते तयार करा',
    namePlaceholder: 'आपले नाव प्रविष्ट करा',
    emailPlaceholder: 'आपला ईमेल प्रविष्ट करा',
    passwordPlaceholder: 'आपला पासवर्ड प्रविष्ट करा',
    confirmPasswordPlaceholder: 'पासवर्ड पुष्टी करा',
  },
  register: {
    badge: 'महाराष्ट्र वारसा • गडकोट',
    pageTitle: 'वारसा नोंदणी — गडकोट सदस्य व्हा',
    pageSubtitle: 'खाते तयार करा आणि आपले ट्रेक, भेट दिलेले गड, मंदिरे व वाडे — ऐतिहासिक प्रवास नोंदवा.',
    stepsLabel: 'नोंदणीच्या पायऱ्या',
    stepAccount: 'खाते',
    stepHeritage: 'वारसा तपशील',
    previewLabel: 'आपली वारसा नोंद',
    heritageScore: 'वारसा गुण',
    continueHeritage: 'वारसा तपशीलाकडे पुढे जा',
    heritageIntro: 'आपल्या ऐतिहासिक प्रवासाची माहिती भरा — हे तपशील प्रोफाइलवर दिसतील आणि शोधक पदवी ठरवण्यास मदत करतील.',
    treksCompleted: 'पूर्ण केलेले ट्रेक',
    fortsVisited: 'भेट दिलेले गड',
    templesVisited: 'भेट दिलेली मंदिरे',
    wadasVisited: 'भेट दिलेले वाडे',
    heritageSitesVisited: 'भेट दिलेली वारसा स्थळे',
    yearsExploring: 'वारसा शोधण्याची वर्षे',
    homeDistrict: 'गृह जिल्हा',
    homeDistrictPlaceholder: 'उदा. पुणे, सातारा',
    favoriteEra: 'आवडता ऐतिहासिक काल',
    eraShiv: 'छत्रपती शिवाजी महाराज काल',
    eraPeshwa: 'पेशवे काल',
    eraAncient: 'प्राचीन व मध्ययुगीन',
    eraAll: 'सर्व काल',
    bioLabel: 'वारसा कथा (ऐच्छिक)',
    bioPlaceholder: 'गड, ट्रेक, मंदिरे किंवा मराठी इतिहासाबद्दलचा आपला अनुभव लिहा…',
    back: 'मागे',
    createAndJoin: 'खाते तयार करा व सामील व्हा',
    rankPathfinder: 'मार्गदर्शक',
    rankFortWalker: 'गड पायदळ',
    rankGuardian: 'वारसा रक्षक',
    rankChronicler: 'इतिहास लेखक',
    heritageProfileTitle: 'वारसा प्रोफाइल',
    editHeritage: 'वारसा तपशील संपादित करा',
    noHeritageYet: 'नोंदणीदरम्यान वारसा तपशील जोडा किंवा खाली संपादित करा.',
    namePlaceholder: 'आपले नाव',
    signInRequired: 'प्रोफाइल पाहण्यासाठी कृपया साइन इन करा',
  },
  ui: {
    pleaseWait: 'कृपया प्रतीक्षा करा…',
    goBack: 'मागे जा',
    save: 'जतन करा',
    cancel: 'रद्द करा',
    close: 'बंद करा',
  },
  errors: {
    seoTitle404: '404 — पृष्ठ सापडले नाही | गडकोट',
    notFoundBadge: 'सह्याद्रीच्या मार्गात हरवले',
    notFoundTitle: 'पृष्ठ सापडले नाही',
    notFoundMessage:
      'आपण शोधत असलेले पृष्ठ अस्तित्वात नाही. चला महाराष्ट्राच्या वारसाचा शोध पुन्हा सुरू करूया.',
    notFoundQuote:
      'मार्ग अस्पष्ट असेल तेव्हा ओळखलेल्या गडद्वाराकडे परत या — स्वराज्याचा प्रवास तेथून पुन्हा सुरू होतो.',
    notFoundQuoteAttr: '— वारसा प्रवासीची नोंद',
    notFoundStory:
      'रात्री बंद झालेल्या गुप्त गडद्वारासारखे, हे पत्ते अद्याप गडकोट नकाशावर नोंदलेले नाही. खालील मार्ग निवडा आणि गड, देवस्थाने व इतिहासाचा प्रवास सुरू ठेवा.',
    heritagePaths: 'मार्ग शोधा — वारसा दुवे',
    continueJourney: 'गडांपासून इतिहासपटांपर्यंत — खऱ्या वारसा मार्ग',
    pathForts: 'स्वराज्याचे गिरिदुर्ग',
    pathFortsDesc: 'रायगड, राजगड, शिवनेरी आणि शेकडो महाराष्ट्रातील गड',
    pathTemples: 'पवित्र देवस्थाने',
    pathTemplesDesc: 'गडांवरील मंदिरे आणि भक्ती मार्ग',
    pathHeritage: 'वारसा केंद्र',
    pathHeritageDesc: 'सरदार, ऐतिहासिक ठिकाण, गॅलरी, भागीदार आणि पुस्तके',
    pathHistory: 'इतिहास व कालखंड',
    pathHistoryDesc: 'ऐतिहासिक लेख, नकाशे आणि “आजचा इतिहास”',
    pathBooks: 'वारसा पुस्तके',
    pathBooksDesc: 'मराठी गड इतिहास आणि मार्गदर्शिका ऑनलाइन वाचा',
    pathSearchDesc: 'गड, मंदिर, वाडे आणि ऐतिहासिक ठिकाणे शोधा',
    backToSafety: 'मुख्यपृष्ठावर परत (गडद्वार)',
    aboutGadkot: 'गडकोट बद्दल',
    heritageClosing: 'महाराष्ट्राचे गड शतकानशत उभे आहेत — हा एक छोटा वळसा फक्त.',
    goHome: 'मुख्यपृष्ठावर जा',
    searchSite: 'साइट शोधा',
    whatNext: 'पुढे काय करावे',
    suggestion1: 'URL मधील शब्दलेखन तपासा',
    suggestion2: 'गड, मंदिरे किंवा ठिकाण शोधण्यासाठी शोध वापरा',
    suggestion3: 'खालील लोकप्रिय श्रेणी पहा',
    suggestion4: 'मुख्यपृष्ठावर परत जा आणि शोध सुरू करा',
    tipLabel: 'टीप:',
    tipText: 'कोणत्याही पृष्ठावरील शोध पट्टीद्वारे गडआणि मंदिरे लवकर शोधा.',
    popularDestinations: 'लोकप्रिय ठिकाणे',
    exploreNow: 'आता शोधा →',
    stillCantFind: 'अजूनही हवे असलेले सापडत नाही?',
    searchPlaceholder: 'गड, मंदिरे, ठिकाणे शोधा…',
    popularSearches: 'लोकप्रिय शोध:',
    needHelp: 'मदत हवी आहे?',
    needHelpText:
      'हे चूक वाटत असल्यास, महाराष्ट्राचा ऐतिहासिक वारसा शोधण्यात आम्ही मदत करू शकतो.',
    contactSupport: 'सहाय्याशी संपर्क',
    reportIssue: 'समस्या नोंदवा',
    quickForts: 'ऐतिहासिक गड',
    quickTemples: 'पवित्र मंदिरे',
    genericTitle: 'काहीतरी चुकले',
    genericMessage: 'कृपया पुन्हा प्रयत्न करा किंवा मुख्यपृष्ठावर परत जा.',
    backHome: 'मुख्यपृष्ठावर परत',
  },
  geo: {
    title: 'भौगोलिक शोध',
    subtitle: 'प्रदेशानुसार महाराष्ट्रातील गडआणि मंदिरे पहा',
    heritageBadge: 'महाराष्ट्र • प्रदेश • वारसा',
    searchPlaceholder: 'नाव किंवा ठिकाणानुसार शोधा…',
    allRegions: 'सर्व प्रदेश',
    allTypes: 'सर्व',
    forts: 'गड',
    temples: 'मंदिरे',
    thematicRoutes: 'विषयक मार्ग',
    viewForts: 'सर्व गड',
    viewTemples: 'सर्व मंदिरे',
    sitesFound: '{{count}} ठिकाणे',
    fortCount: '{{count}} गड',
    templeCount: '{{count}} मंदिरे',
    loading: 'ठिकाणे लोड होत आहेत…',
    loadError: 'ठिकाणे लोड होऊ शकली नाहीत. बॅकएंड चालू आहे का?',
    noResults: 'आपल्या फिल्टरशी जुळणारी ठिकाणे नाहीत',
    noResultsHint: 'दुसरा प्रदेश किंवा शोध शब्द वापरून पहा',
    built: 'बांधकाम',
    difficulty: 'अवघडपणा',
    deity: 'देवता',
  },
  search: {
    title: 'शोध',
    subtitle: 'गड, मंदिरे आणि वारसा ठिकाणे शोधा',
    heritageBadge: 'गड • मंदिरे • वारसा',
    placeholder: 'गड , मंदिरे, ठिकाणे शोधा…',
    searchButton: 'शोधा',
    showingResults: '{{count}} निकाल दाखवत आहे',
    matchPercent: '{{percent}}% जुळणी',
    filterLabel: 'फिल्टर',
    categoryAll: 'सर्व श्रेणी',
    categoryFort: 'गड',
    categoryTemple: 'मंदिरे',
    categoryBlog: 'ब्लॉग',
    categoryRegion: 'प्रदेश',
    categoryRoute: 'मार्ग',
    sortRelevance: 'सर्वात संबंधित',
    sortName: 'नाव (अ–ज)',
    sortYear: 'वर्ष (जुने प्रथम)',
    sortHeight: 'उंची (सर्वाधिक)',
    sortBy: 'क्रमवारी',
    tipsTitle: 'शोधण्याचा प्रयत्न करा',
    tipSpelling: 'शब्दलेखन किंवा पर्यायी नावे तपासा',
    tipKeywords: 'विस्तृत शब्द (उदा. सह्याद्री, शिवाजी)',
    tipBrowse: 'मुख्यपृष्ठावरून गड किंवा मंदिरे पहा',
    noResults: 'निकाल सापडले नाहीत',
    noResultsFor: '"{{query}}" साठी निकाल सापडले नाहीत',
    noResultsHint: 'वेगळा शोध शब्द वापरून पहा',
    searching: 'शोधत आहे…',
    resultsFor: '"{{query}}" साठी निकाल',
    resultsCount: '{{count}} निकाल सापडले',
    allItems: 'सर्व घटक',
    errorLoading: 'शोध निकाल लोड होऊ शकले नाहीत',
    searchingTitle: 'शोधत आहे...',
    searchingHint: 'आपल्यासाठी सर्वोत्तम निकाल शोधत आहे',
    filters: 'फिल्टर',
    signInToFavorite: 'आवडीमध्ये जोडण्यासाठी कृपया साइन इन करा',
    linkCopied: 'दुवा क्लिपबोर्डवर कॉपी झाला!',
    typeFort: 'ऐतिहासिक गड',
    typeTemple: 'पवित्र मंदिर',
    typeBlog: 'ब्लॉग',
    typeRegion: 'भौगोलिक प्रदेश',
    typeRoute: 'विषयक मार्ग',
    typeSite: 'ठिकाण',
  },
  adminSidebar: {
    title: 'प्रशासन',
    subtitle: 'गडकोट वारसा',
    uploadManage: 'अपलोड आणि व्यवस्थापन',
    blogModeration: 'ब्लॉग पुनरावलोकन',
    mediaLibrary: 'माध्यम संग्रह',
    organizations: 'संस्था',
    eventApprovals: 'कार्यक्रम मंजुरी',
    thematicRoutes: 'विषयक मार्ग',
    dailyHistory: 'आजचा इतिहास',
    weapons: 'शस्त्रे व माहिती',
  },
  weapons: {
    seoDescription: 'मराठा कालखंड, स्वराज्य आणि भारतीय युद्धशास्त्रातील ऐतिहासिक शस्त्रांची माहिती.',
    subtitle: 'तलवार, भाला, ढाल, तोफ आणि इतर ऐतिहासिक शस्त्रांचा सविस्तर परिचय.',
    loadError: 'शस्त्रांची माहिती लोड होऊ शकली नाही.',
    noResults: 'या श्रेणीत अद्याप कोणतेही शस्त्र नोंदवलेले नाही.',
    notFound: 'शस्त्र सापडले नाही.',
    searchPlaceholder: 'शस्त्र शोधा (उदा. तलवार, भाला)…',
    resultsCount: '{{count}} शस्त्रे सापडली',
    viewDetails: 'तपशील पहा',
    backToHub: 'शस्त्रे व माहिती',
    allWeapons: 'सर्व शस्त्रे',
    prevPage: 'मागील',
    nextPage: 'पुढील',
    gallery: 'प्रतिमा गॅलरी',
    noGallery: 'अद्याप प्रतिमा उपलब्ध नाहीत.',
    zoom: 'मोठे पहा',
    relatedWeapons: 'संबंधित शस्त्रे',
    categories: {
      edged: 'धारदार शस्त्रे',
      piercing: 'भोसकणारी शस्त्रे',
      projectile: 'प्रक्षेपण शस्त्रे',
      firearms: 'अग्निशस्त्रे',
      defensive: 'संरक्षणात्मक शस्त्रे',
    },
    sections: {
      intro: 'परिचय',
      detailed: 'सविस्तर माहिती',
      history: 'इतिहास',
      usage: 'वापर',
      advantages: 'फायदे',
      disadvantages: 'तोटे',
      famousUsage: 'प्रसिद्ध उपयोग',
      relatedForts: 'संबंधित किल्ले',
      relatedPersonalities: 'संबंधित ऐतिहासिक व्यक्ती',
    },
    specs: {
      title: 'तांत्रिक माहिती',
      type: 'प्रकार',
      period: 'कालखंड',
      weight: 'वजन',
      length: 'लांबी / आकार',
      material: 'साहित्य',
    },
  },
  adminOrganizations: {
    title: 'संस्था डॅशबोर्ड',
    subtitle: 'संस्था, गट आणि मंडळे तयार व व्यवस्थापित करा. फक्त प्रशासक जोड, संपादन किंवा हटवू शकतात.',
    addOrg: 'संस्था जोडा',
    editOrg: 'संस्था संपादित करा',
    newOrg: 'नवीन संस्था',
    refresh: 'रिफ्रेश',
    search: 'शोध',
    filterCategory: 'वर्ग',
    noOrgs: 'अद्याप कोणतीही संस्था नाही. सुरुवात करण्यासाठी एक जोडा.',
    saveFirstHint: 'प्रथम संस्था जतन करा, नंतर गॅलरी, कार्यक्रम, सदस्य आणि कागदपत्रे जोडू शकता.',
    stats: {
      orgs: 'संस्था',
      categories: 'वर्ग',
      members: 'सदस्य',
      events: 'कार्यक्रम',
      districts: 'जिल्हे',
    },
  },
  home: {
    heritageBadge: 'मराठा वारशाचे भव्य प्रवेशद्वार',
    heritageMotto: 'गड • मंदिरे • इतिहास • संस्कृती',
    visitCounterLabel: 'वारसाच्या प्रवेशद्वारी — गडकोटला पावले टाकलेले अभ्यागत',
    todayPick: {
      badge: 'दैनिक सूचना',
      title: 'आज काय पाहायचे?',
      subtitle: 'आजची तिथी, वैशिष्ट्यपूर्ण गड व मंदिर, आणि ऋतू-हवामान मार्गदर्शन — सर्व वारसा डेटाबेसवरून.',
      tithiLabel: 'आजची तिथी घटना',
      fortLabel: 'आजचा गड',
      templeLabel: 'आजचे मंदिर',
      seasonLabel: 'ऋतू आणि हवामान',
      loading: 'आजची वारसा निवड लोड होत आहे…',
      error: 'आजची निवड लोड होऊ शकली नाही',
      readTithi: 'अधिक वाचा',
      openCalendar: 'तिथी कॅलेंडर पहा',
      viewFort: 'गड पहा',
      viewTemple: 'मंदिर पहा',
      liveWeather: 'थेट अंदाज (वैशिष्ट्यपूर्ण गड)',
      trekCaution: 'ट्रेक सावध',
      viewFull: 'संपूर्ण विभाग पहा',
      errorHint: 'बॅकएंड रीस्टार्ट करा आणि GET /api/v1/site/today-heritage-pick तपासा — होम पेजवर हिरो खाली हा विभाग दिसेल.',
    },
    readAllBlogs: 'सर्व ब्लॉग वाचा',
    writeYourStory: 'आपली कथा लिहा',
    exploreHeritage: 'वारसा अन्वेषण',
    exploreHeritageSubtitle: 'आमच्या निवडक संग्रहाद्वारे भारताचा समृद्ध ऐतिहासिक वारसा शोधा',
    geoExplorerDesc: 'विविध प्रदेश आणि विषयांतील ऐतिहासिक ठिकाणे शोधा',
    geoExplorerCta: 'शोधा',
    thematicRoutesDesc: 'इतिहासातील निवडक प्रवास आणि मार्ग',
    thematicRoutesCta: 'आविष्कार करा',
    historicalFortsTitle: 'ऐतिहासिक गड',
    historicalFortsDesc: 'महाराष्ट्राचे भव्य गडकोट आणि दुर्ग अनुभवा',
    historicalFortsCta: 'भेट द्या',
    sacredTemplesTitle: 'पवित्र मंदिरे',
    sacredTemplesDesc: 'आध्यात्मिक वारसाचा अनुभव घ्या',
    sacredTemplesCta: 'दर्शन घ्या',
    searchSites: 'ठिकाणे शोधा',
    learnMore: 'अधिक जाणून घ्या',
    contactUs: 'संपर्क करा',
    featuredFortsTitle: 'वैशिष्ट्यपूर्ण गड',
    featuredFortsSubtitle: 'महाराष्ट्राचे वैभवशाली गडकोट पहा',
    featuredSections: {
      title: 'अन्वेषण सुरू करा',
      subtitle: 'महाराष्ट्राच्या वारशात प्रवेश — चार मार्ग, एक निवड.',
      forts: {
        title: 'गड आणि ट्रेक',
        desc: 'नकाशे, ट्रेक मार्गदर्शक आणि तुमच्या स्थानापासून जवळचे गड — सर्व एकाच ठिकाणी.',
        cta: 'गड पहा',
      },
      map: {
        title: 'नकाशा आणि प्रदेश',
        desc: 'जिल्हा, प्रदेश आणि थीमॅटिक मार्गांनुसार गड आणि वारसा ठिकाणे.',
        cta: 'नकाशा उघडा',
      },
      events: {
        title: 'कार्यक्रम दिनदर्शिका',
        desc: 'गड महोत्सव, वारसा पायाळ पदयात्रा, जत्रा आणि सामुदायिक कार्यक्रम.',
        cta: 'कार्यक्रम पहा',
      },
      trek: {
        title: 'ट्रेक नियोजक',
        desc: 'मार्ग, चेकलिस्ट, हंगामी सूचना आणि गटासोबत live ट्रेक स्थिती.',
        cta: 'ट्रेक नियोजित करा',
      },
    },
    viewAllForts: 'सर्व गड पहा',
    viewFort: 'किल्ला पहा',
    loadingForts: 'गड लोड होत आहेत…',
    noFeaturedForts: 'सध्या गड उपलब्ध नाहीत. लवकरच पुन्हा तपासा.',
    fortLoadError: 'वैशिष्ट्यपूर्ण गड लोड होऊ शकले नाहीत',
    features: {
      badge: 'सर्व सुविधा एका ठिकाणी',
      title: 'गडकोटमध्ये काय शोधू शकता?',
      subtitle: 'गड, मंदिरे, ट्रेक साधने आणि समुदाय — महाराष्ट्राचा वारसा अनुभवण्यासाठी आवश्यक सर्व काही.',
      openFeature: 'पहा',
      ctaTrek: 'ट्रेक नियोजक उघडा',
      ctaForts: 'सर्व गड पहा',
      categories: {
        explore: 'वारसा आणि अन्वेषण',
        trek: 'ट्रेक आणि साधने',
        community: 'समुदाय',
        discover: 'शोध आणि मार्ग',
      },
      forts: {
        title: 'ऐतिहासिक गड',
        desc: 'सविस्तर माहिती, नकाशे, कालरेखा आणि ट्रेक मार्गदर्शकासह महाराष्ट्राचे गड.',
      },
      temples: {
        title: 'पवित्र मंदिरे',
        desc: 'प्राचीन मंदिरे, ज्योतिर्लिंग आणि आध्यात्मिक वारसा शोधा.',
      },
      wades: {
        title: 'ऐतिहासिक वाडे',
        desc: 'हवेली, वाडे आणि सांस्कृतिक वास्तूचा वारसा.',
      },
      history: {
        title: 'इतिहास',
        desc: 'मराठा साम्राज्य, लढाई आणि महाराष्ट्राची कालखंड.',
      },
      weapons: {
        title: 'शस्त्र संग्रह',
        desc: 'तलवार, भाला, ढाल, तोफ आणि इतिहासिक शस्त्रांची माहिती.',
      },
      blog: {
        title: 'ब्लॉग',
        desc: 'इतिहासप्रेमी आणि प्रवाशांच्या कथा, लेख आणि अनुभव.',
      },
      search: {
        title: 'स्मार्ट शोध',
        desc: 'गड, मंदिरे आणि वारसा ठिकाणे नाव, प्रदेश किंवा विषयानुसार शोधा.',
      },
      events: {
        title: 'कार्यक्रम दिनदर्शिका',
        desc: 'गड उत्सव, जत्रा, ट्रेक आणि वारसा पायऱ्या — संस्थांचे कार्यक्रम.',
      },
      trekPlanner: {
        title: 'ट्रेक नियोजक',
        desc: 'गट ट्रेक तयार करा, सामील व्हा आणि सह्याद्रीत साहस नियोजित करा.',
      },
      nearbyForts: {
        title: 'जवळचे गड',
        desc: 'GPS किंवा कोणतेही शहर — तुमच्या स्थानापासून खरी अंतरे आणि वारसा नकाशा.',
      },
      checklist: {
        title: 'ट्रेक चेकलिस्ट',
        desc: 'सामान, सुरक्षा आणि हंगामानुसार तयारीची यादी — ऑफलाइनही.',
      },
      weather: {
        title: 'हवामान आणि मार्गदर्शक',
        desc: 'प्रत्येक गडावर ट्रेक मार्गदर्शक, हवामान आणि आपत्कालीन संपर्क.',
      },
      liveStatus: {
        title: 'थेट ट्रेक स्थिती',
        desc: 'कुटुंबासाठी सुरक्षित लिंक — ट्रेकवर असताना थेट स्थान सामायिक करा.',
      },
      trekDiary: {
        title: 'ट्रेक डायरी',
        desc: 'फोटो, नोट्स आणि आठवणी — आपला ट्रेक अनुभव नोंदवा.',
      },
      seasonal: {
        title: 'हंगामानुसार ट्रेक',
        desc: 'पावसाळा, हिवाळा आणि उन्हाळ्यात कोणते गड योग्य — हंगामी शिफारसी.',
      },
      contributions: {
        title: 'योगदान',
        desc: 'फोटो, माहिती आणि अनुभव सामायिक करा — वारसा जतन करण्यात मदत करा.',
      },
      organizations: {
        title: 'संस्था आणि मंडळे',
        desc: 'गड, इतिहास आणि वारशाशी संबंधित संस्था, गट आणि मंडळे.',
      },
      buddyFinder: {
        title: 'ट्रेक मित्र शोध',
        desc: 'समुदाय ट्रेकमध्ये सामील व्हा किंवा गट तयार करा — एकटे ट्रेक नको.',
      },
      expenseSplit: {
        title: 'खर्च विभाजन',
        desc: 'ट्रेक खर्च गटात विभागा — प्रवास, जेवण आणि इतर खर्च सोपे.',
      },
      geoExplorer: {
        title: 'भौगोलिक शोध',
        desc: 'प्रदेश, जिल्हा आणि नकाशावरून गड आणि मंदिरे शोधा.',
      },
      thematicRoutes: {
        title: 'विषयक मार्ग',
        desc: 'इतिहास, साम्राज्य आणि वारशावर आधारित निवडक प्रवास मार्ग.',
      },
    },
  },
  allForts: {
    title: 'महाराष्ट्रातील गड',
    subtitle: 'सह्याद्री आणि कोकणातील ऐतिहासिक गड, किल्ले आणि ट्रेकिंग मार्ग शोधा',
    fortsFound: 'गड सापडले',
    gridView: 'यादी दृश्य',
    mapView: 'नकाशा दृश्य',
    searchPlaceholder: 'नाव, जिल्हा किंवा प्रकारानुसार शोधा…',
    allLocations: 'सर्व जिल्हे',
    sortByName: 'नावानुसार',
    sortByLocation: 'स्थानानुसार',
    sortByHeight: 'उंचीनुसार',
    sortByYear: 'वर्षानुसार',
    sortByDifficulty: 'अवघडपणानुसार',
    sortByPopularity: 'लोकप्रियतेनुसार',
    advancedFilters: 'प्रगत फिल्टर',
    clearFilters: 'फिल्टर साफ करा',
    difficulty: 'अवघडपणा',
    allDifficulties: 'सर्व',
    fortType: 'गडाचा प्रकार',
    allTypes: 'सर्व प्रकार',
    region: 'प्रदेश',
    allRegions: 'सर्व प्रदेश',
    heightRange: 'उंची श्रेणी',
    yearRange: 'बांधकाम वर्ष श्रेणी',
    trendingForts: 'लोकप्रिय गड',
    recentlyVisited: 'अलीकडे पाहिलेले',
    visits: 'भेटी',
    noFortsFound: 'कोणतेही गड सापडले नाहीत',
    tryDifferentSearch: 'शोध शब्द किंवा फिल्टर बदलून पहा',
    viewDetails: 'तपशील पहा',
    loading: 'गड लोड होत आहेत…',
    loadError: 'गड लोड होऊ शकले नाहीत.',
    mapListTitle: 'नकाशावरील गड',
    mapHint: 'चिन्ह किंवा यादीतील नावावर टॅप करून गड नकाशावर पहा. ट्रेक आणि इतिहासासाठी तपशील पहा.',
  },
  fortsPage: {
    built: 'बांधकाम',
    bestTime: 'भेटीसाठी उत्तम वेळ',
  },
  temples: {
    heritageBadge: 'पवित्र मंदिरे • वारसा • महाराष्ट्र',
    templesCountLabel: 'मंदिरे',
    templesFound: '{{count}} मंदिरे सापडली',
    searchPlaceholder: 'नाव, स्थान किंवा देवतेनुसार शोधा…',
    loading: 'मंदिरे लोड होत आहेत…',
    loadError: 'मंदिरे लोड होऊ शकली नाहीत. बॅकएंड चालू आहे का?',
    noTemples: 'कोणतेही मंदिर सापडले नाही',
    noTemplesHint: 'शोध शब्द बदलून पहा किंवा नंतर पुन्हा तपासा',
    viewForts: 'गड पहा',
    viewTemple: 'मंदिर पहा',
    badge: 'मंदिर',
    seoTitle: 'पवित्र मंदिरे — महाराष्ट्र वारसा | गडकोट',
    seoDescription: 'महाराष्ट्रातील प्राचीन मंदिरे, ज्योतिर्लिंग आणि आध्यात्मिक वारसा शोधा.',
    notFound: 'मंदिर सापडले नाही',
    notFoundHint: 'विनंती केलेले मंदिर अस्तित्वात नाही.',
    backToTemples: 'सर्व मंदिरांकडे',
    about: 'बद्दल',
    keyFeatures: 'मुख्य वैशिष्ट्ये',
    deity: 'देवता',
    bestTime: 'भेटीसाठी उत्तम वेळ',
  },
  templeDetail: {
    heritageBadge: 'पवित्र मंदिर • वारसा • महाराष्ट्र',
    keyInformation: 'मुख्य माहिती',
    quickInfo: 'त्वरित माहिती',
    location: 'स्थान',
    deity: 'देवता',
    bestTime: 'भेटीसाठी उत्तम वेळ',
    visitingHours: 'दर्शन वेळ',
    visitingHoursDefault: 'सकाळी ६ — रात्री ८ (दररोज)',
    keyFeatures: 'मुख्य वैशिष्ट्ये',
    noFeatures: 'अद्याप मुख्य वैशिष्ट्ये नोंदलेली नाहीत.',
    onMap: 'नकाशावरील स्थान',
    audioGuideTitle: 'ऑडिओ मार्गदर्शक',
    audioGuideDescription: 'या मंदिराबद्दल मराठी कथा ऐका.',
    startAudioGuide: 'ऑडिओ मार्गदर्शक सुरू करा',
    audioGuide: 'ऑडिओ मार्गदर्शक',
    gallery: 'चित्रगॅलरी',
    visitInfo: 'भेट माहिती',
    dressCode: 'पोशाख',
    dressCodeDefault: 'साधा पोशाख आवश्यक. खांदे व गुडघे झाकलेले असावेत.',
    photography: 'छायाचित्रण',
    photographyDefault: 'बहुतेक ठिकाणी परवानगी. गर्भगृहाजवळ मर्यादा असू शकतात.',
    facilities: 'सुविधा',
    facilitiesDefault: 'पार्किंग, स्वच्छतागृह आणि पिण्याचे पाणी उपलब्ध.',
    howToReach: 'कसे पोहोचाल',
    howToReachDefault: 'जवळच्या शहरांकडून रस्त्याने सहज पोहोच.',
    share: 'शेअर करा',
    signInForFavorites: 'आवडीत जोडण्यासाठी कृपया साइन इन करा.',
    linkCopied: 'लिंक क्लिपबोर्डवर कॉपी झाली!',
  },
  quiz: {
    title: 'वारसा प्रश्नमंजुषा',
    subtitle: 'गड, मंदिरे आणि इतिहासावरील आपले ज्ञान तपासा',
    category: 'श्रेणी',
    difficulty: 'अवघडपणा',
    questionCount: 'प्रश्नांची संख्या',
    startQuiz: 'प्रश्नमंजुषा सुरू करा',
    loading: 'लोड होत आहे…',
    question: 'प्रश्न',
    of: 'पैकी',
    finish: 'समाप्त',
    results: 'निकाल',
    score: 'गुण',
    correct: 'बरोबर',
    incorrect: 'चुकीचे',
    tryAgain: 'पुन्हा प्रयत्न',
    selectCategory: 'श्रेणी निवडा',
    selectDifficulty: 'अवघडपणा निवडा',
    metaError: 'प्रश्नमंजुषा पर्याय लोड होऊ शकले नाहीत',
    sessionError: 'प्रश्नमंजुषा सुरू होऊ शकली नाही',
    submitError: 'उत्तर सादर होऊ शकले नाही',
    subtitleDb: 'प्रश्न बॅकएंड डेटाबेसमधून लोड होतात.',
    startNew: 'नवीन प्रश्नमंजुषा सुरू करा',
    startDesc: 'पर्यायी फिल्टर निवडा आणि सुरू करा. बरोबर उत्तरे सर्व्हरवर तपासली जातात.',
    allCategories: 'सर्व श्रेणी',
    allDifficulties: 'सर्व अवघडपणा',
    questionsLabel: 'प्रश्न',
  },
  trek: {
    title: 'ट्रेक नियोजक',
    subtitle: 'गट ट्रेक नियोजित करा, कोण येत आहे ते पहा आणि पुढील साहसांमध्ये सामील व्हा.',
    heritageBadge: 'सह्याद्री • गड • समुदाय',
    statUpcoming: 'येणारे ट्रेक',
    statPast: 'मागील ट्रेक',
    statCommunity: 'सहभागी',
    newTrekPlan: 'नवीन ट्रेक योजना',
    upcoming: 'येणारे',
    past: 'मागील',
    join: 'सामील व्हा',
    youreIn: 'तुम्ही सामील आहात',
    signInToJoin: 'येणाऱ्या ट्रेकमध्ये सामील होण्यासाठी साइन इन करा',
    createdBy: 'यांनी तयार केले',
    participants: 'सहभागी',
    noParticipants: 'अद्याप कोणी सहभागी नाही.',
    loadError: 'ट्रेक योजना लोड होऊ शकल्या नाहीत',
    joinError: 'या ट्रेकमध्ये सामील होता आले नाही',
    createError: 'ट्रेक योजना तयार होऊ शकली नाही',
    loading: 'ट्रेक योजना लोड होत आहेत…',
    serverErrorTitle: 'सर्व्हरशी संपर्क होऊ शकला नाही',
    upcomingTreks: 'येणारे ट्रेक',
    pastTreks: 'मागील ट्रेक',
    noUpcoming: 'अद्याप येणारे ट्रेक नाहीत. सर्वप्रथम एक तयार करा.',
    noPast: 'दाखवण्यासाठी मागील ट्रेक नाहीत.',
    createTrekPlan: 'ट्रेक योजना तयार करा',
    formTitle: 'शीर्षक',
    formLocation: 'ठिकाण',
    formTrekDate: 'ट्रेक तारीख',
    formDescription: 'वर्णन',
    placeholderTitle: 'उदा. रायगड रात्र ट्रेक',
    placeholderLocation: 'उदा. पुणे, महाराष्ट्र',
    placeholderDescription: 'भेट ठिकाण, अवघडपणा, काय आणावे…',
    cancel: 'रद्द करा',
    save: 'जतन करा',
    unknown: 'अज्ञात',
    user: 'वापरकर्ता',
    hubCommunity: 'समुदाय ट्रेक',
    hubChecklist: 'चेकलिस्ट',
    hubOffline: 'ऑफलाइन',
    hubLive: 'मी ट्रेकवर',
    hubLog: 'ट्रेक डायरी',
    hubSeasonal: 'हंगामानुसार',
    formMaxParticipants: 'जास्तीत जास्त सहभागी',
    formDifficulty: 'अवघडपणा',
    checklist: {
      water_bottle: 'पाण्याची बाटली (२–३ लिटर)',
      snacks: 'हलका नाश्ता / फळे',
      trek_shoes: 'ट्रेकिंग शूज',
      cap_sunscreen: 'टोपी आणि सनस्क्रीन',
      first_aid: 'प्राथमिक उपचार किट',
      id_card: 'ओळखपत्र',
      power_bank: 'पॉवर बँक',
      raincoat: 'रेनकोट / पाऊसाचे कपडे',
      head_torch: 'हेड टॉर्च',
      extra_batteries: 'अतिरिक्त बॅटरी',
      warm_layer: 'उबदार थर / जॅकेट',
      whistle: 'शिट्टी',
      waterproof_bag: 'वॉटरप्रूफ बॅग',
      extra_clothes: 'अतिरिक्त कपडे',
      anti_leech_socks: 'जळग बचाव मोजे',
      warm_jacket: 'उबदार जॅकेट',
      gloves: 'हातमोजे',
      energy_bars: 'एनर्जी बार',
    },
  },
  trekEssentials: {
    title: 'ट्रेक मार्गदर्शक',
    weather: 'हवामान व सुरक्षा',
    trekSafe: 'ट्रेकसाठी योग्य',
    trekCaution: 'सावधान — पाऊस/वादळ',
    bestStart: 'सुरुवातीची वेळ',
    bestSeason: 'सर्वोत्तम हंगाम',
    baseVillage: 'बेस गाव',
    parking: 'पार्किंग',
    duration: 'कालावधी',
    beginner: 'नवशिक्या',
    fit: 'तज्ञ',
    monsoonSafe: 'पावसाळ्यात सुरक्षित ट्रेक',
    monsoonCaution: 'पावसाळ्यात अतिरिक्त सावधानी घ्या',
    waterPoints: 'पाण्याचे ठिकाण',
    foodPoints: 'जेवण / दुकाने',
    transport: 'वाहतूक',
    bus: 'बस',
    train: 'रेल्वे',
    jeep: 'जीप / शेअर टॅक्सी',
    lastReturn: 'शेवटची परती',
    emergency: 'आपत्कालीन संपर्क',
    trailConditions: 'अलीकडील मार्ग अहवाल',
    noReports: 'अद्याप अहवाल नाहीत.',
    reportPlaceholder: 'मार्गाची स्थिती लिहा…',
    submitReport: 'अहवाल पाठवा',
    saveOffline: 'ऑफलाइन जतन करा',
    offlineSaved: 'गड माहिती या डिव्हाइसवर जतन झाली.',
    openTrekHub: 'ट्रेक नियोजक उघडा',
    checklistTitle: 'ट्रेक चेकलिस्ट',
    checklistTypes: { day: 'दिवस', night: 'रात्र', monsoon: 'पावसाळा', winter: 'हिवाळा' },
    liveStatusTitle: 'मी ट्रेकवर आहे',
    liveStatusDesc: 'कुटुंबीयांसोबत स्थिती शेअर करा — सुरक्षित पोहोचल्यावर “सुरक्षित घरी” दाबा.',
    liveStatuses: {
      started: 'ट्रेक सुरू',
      at_top: 'शिखरावर',
      descending: 'उतरत आहे',
      safe_home: 'सुरक्षित घरी',
    },
    shareWithFamily: 'कुटुंबासाठी दुवा',
    copyLink: 'कॉपी',
    logTitle: 'माझी ट्रेक डायरी',
    fortId: 'गड ID',
    fortIdOptional: 'गड ID (ऐच्छिक)',
    durationHours: 'तास',
    distanceKm: 'अंतर (किमी)',
    logNotes: 'नोंदी',
    addLog: 'नोंद जोडा',
    seasonalTitle: 'या हंगामात योग्य गड',
    noSeasonal: 'सध्या सूचना उपलब्ध नाहीत.',
    seasonal: {
      currentSeason: 'सध्या हंगाम',
      tipsTitle: 'हंगामी सूचना',
      avoidTitle: 'सावधान रहा',
      packingTitle: 'काय सोबत घ्यावे',
      recommended: 'या हंगामात शिफारस केलेले गड',
      filterDistrict: 'जिल्हा निवडा',
      allDistricts: 'सर्व जिल्हे',
      noForts: 'या फिल्टरसाठी गड सापडले नाहीत.',
      viewFort: 'गड तपशील पहा',
      browseAllForts: 'सर्व गड पहा',
      openChecklist: 'चेकलिस्ट उघडा',
      reasons: {
        winterBest: 'ऑक्टोबर–फेब्रुवारी — ट्रेकिंगसाठी सर्वोत्तम हंगाम.',
        summerEarly: 'सकाळी लवकर सुरू करा — उन्हाळ्यात उष्णता वाढते.',
        summerHard: 'कठीण मार्ग — फक्त अनुभवी ट्रेकर्स; पहाटे सुरू करा.',
        monsoonSafe: 'पावसाळ्यात सुरक्षित — स्थानिक मार्गदर्शक घ्या.',
        monsoonCheck: 'पावसाळ्यात मार्ग तपासा — निसर्गरम्य गड.',
        monsoonEasy: 'सोपा/मध्यम मार्ग — पावसाळ्यात अतिरिक्त सावधानी.',
        monsoonHard: 'कठीण गड — पावसाळ्यात टाळणे शक्यतो बरे.',
        general: 'योग्य तयारी आणि हवामान तपासून ट्रेक करा.',
      },
      summer: {
        name: 'उन्हाळा / प्री-मॉन्सून',
        months: 'मार्च – मे',
        intro: 'उन्हाळ्यात सकाळी ५–६ वाजता सुरुवात करा. दुपारी उष्णता, थकवा आणि निर्जलीकरणाचा धोका वाढतो. सोपे व मध्यम गड या काळात योग्य; पाणी, टोपी आणि सनस्क्रीन अत्यावश्यक.',
        bestFor: 'सोपे व मध्यम गड — लोहगड, सिंहगड, तोरणा, कर्जत-जवळचे गड.',
        tip1: 'सूर्योदयापूर्वी किंवा सकाळी ६ वाजता सुरुवात — १० वाजता परत येण्याचे लक्ष्य ठेवा.',
        tip2: 'प्रत्येकास ३–४ लिटर पाणी, ORS/इलेक्ट्रोलाइट आणि ऊस, लिंबाचा सार.',
        tip3: 'हलके रंगाचे कपडे, टोपी, सनस्क्रीन आणि चष्मा घ्या.',
        tip4: 'दगडी/उघड मार्गावर दुपारी ट्रेक टाळा — सावली असलेले मार्ग निवडा.',
        tip5: 'कुटुंबाला वेळ आणि मार्ग कळवा; हवामान अॅपवर नजर ठेवा.',
        avoid1: 'दुपार ११–३ दरम्यान उघड शिखरावर ट्रेक.',
        avoid2: 'पाणी अपुरे असल्यास कठीण/लांब मार्ग.',
        avoid3: 'उष्णतेमुळे थकले असताना उतरणे — विश्रांती घ्या.',
      },
      monsoon: {
        name: 'पावसाळा',
        months: 'जून – सप्टेंबर',
        intro: 'पावसाळ्यात मार्ग ओले व निसरडे होतात, धबधबे सक्रिय असतात आणि पाण्याचा वेग वाढतो. फक्त पावसाळ्यात सुरक्षित समजले जाणारे गड निवडा. पावसाचे कपडे, जळग-प्रतिबंधित मोजे आणि स्पष्ट दृश्य असलेले मार्ग आवश्यक.',
        bestFor: 'पावसाळ्यात सुरक्षित गड — सिंहगड, राजमाची, लोहगड, विसापूर (स्थानिक अहवाल तपासा).',
        tip1: 'हंगामी अहवाल, स्थानिक मार्गदर्शक आणि गडावरील मार्ग अहवाल तपासा.',
        tip2: 'जळग-प्रतिबंधित मोजे, पावसाचे कपडे आणि पाणीरोधक बॅग अवश्यक.',
        tip3: 'गडावर रात्र राहण्याची योजना टाळा — दिवसाचा ट्रेक आणि लवकर परत.',
        tip4: 'वादळ दिसल्यास ताबडतोब उतरा — उघड शिखर टाळा.',
        tip5: 'अतिरिक्त कपडे पाणीरोधक थैलीत — मोबाइलही पाणीरोधक कव्हरमध्ये.',
        avoid1: 'उbड्या दगडी जागी घसरणाने गंभीर इजा होऊ शकते.',
        avoid2: 'धबधबा ओलांडताना पाण्याचा प्रवाह जोरदार असेल तेव्हा.',
      },
      winter: {
        name: 'हिवाळा — सर्वोत्तम ट्रेक हंगाम',
        months: 'ऑक्टोबर – फेब्रुवारी',
        intro: 'सह्याद्रीतील ट्रेkिंगसाठी हा सर्वोत्तम काळ. हवा थंड, दृश्ये स्पष्ट. कठीण गडही या हंगामात योग्य — पण रात्री थंडी आणि लवकर सूर्यास्त लक्षात ठेवा.',
        bestFor: 'सर्व प्रकारचे गड — हरिश्चंदrag, कalsubai, तोरणा, रतnagiri जilheतील गड.',
        tip1: 'डिसें–जानेवारीमध्ये उबदार थर — शिखरावर थंडी वाढते.',
        tip2: 'सूर्यास्त ६–६:३० — रात्री ट्रेkसाठी विद्युतदीप.',
        tip3: 'या हंगामात लोकप्रिय गड गर्दीचे — आठवडyache सaptyaचare disa नivda.',
        tip4: 'Camping साठी permission ghenyasathi va agni suraksha niyam paḷa.',
        tip5: 'Purna-divasache trek — khadyapadaarth, 3+ liter pani va prathamopchar kit.',
        avoid1: 'Dec–Jan madhye ubdaar kapde shivay sakali suruvat.',
        avoid2: 'Surystate nantar yojana na asleli ratri utarani.',
      },
    },
    selectFort: 'गड निवडा',
    seatsLeft: 'जागा शिल्लक',
    expenses: 'खर्च विभाग',
    paidBy: 'भरले',
    expenseDesc: 'खर्चाचे वर्णन',
    amount: 'रक्कम (₹)',
    addExpense: 'खर्च जोडा',
    liveShareTitle: 'ट्रेक स्थिती',
    liveNotFound: 'स्थिती सापडली नाही',
    signInRequired: 'हे वैशिष्ट्य वापरण्यासाठी साइन इन करा.',
    sessionExpired: 'सत्र संपले. कृपया पुन्हा साइन इन करा.',
    liveUpdateError: 'स्थिती अद्यतन करता आली नाही.',
    atFort: 'गड',
    expectedSafe: 'अपेक्षित सुरक्षित वेळ',
    lastUpdate: 'शेवटचे अद्यतन',
    reportTypes: {
      muddy: 'चिखल',
      gate_closed: 'दार बंद',
      leeches: 'जळग',
      waterfall: 'धबधबा',
      other: 'इतर',
    },
  },
  contributions: {
    title: 'योगदान',
    subtitle: 'आपले गड ट्रेक अनुभव सामायिक करा. सार्वजनिक प्रदर्शनापूर्वी सादर केलेली माहिती तपासली जाते.',
    heritageBadge: 'समुदाय • अनुभव • वारसा',
    reviewNote: 'सर्व सादरे प्रशासक पुनरावलोकनानंतरच प्रकाशित होतात.',
    published: 'प्रकाशित',
    gallery: 'गॅलरी',
    submit: 'सादर करा',
    myContributions: 'माझी योगदाने',
    loadError: 'योगदाने लोड होऊ शकली नाहीत',
    loadMineError: 'आपली योगदाने लोड होऊ शकली नाहीत',
    submitError: 'सादर करता आले नाही',
    noPublished: 'अद्याप प्रकाशित योगदान नाही.',
    loadMore: 'अधिक लोड करा',
    loading: 'लोड होत आहे…',
    signInToSubmit: 'योगदान सादर करण्यासाठी साइन इन करा.',
    formTitle: 'शीर्षक',
    formExperience: 'आपला अनुभव',
    formFort: 'किल्ला / ठिकाण',
    formRating: 'रेटिंग (१–५)',
    formDifficulty: 'अवघडपणा',
    formBestTime: 'भेट देण्यासाठी सर्वोत्तम वेळ',
    formTips: 'इतर ट्रेकर्ससाठी टिपा',
    formPhotos: 'फोटो दुवे (ऐच्छिक)',
    formPhotosHint: 'जास्तीत जास्त १० HTTPS प्रतिमा URL, प्रत्येकी एक ओळ.',
    placeholderExperience: 'आपला ट्रेक, काय पाहिले आणि अनुभव कसा होता ते लिहा.',
    placeholderFort: 'उदा. सिंहगड',
    placeholderBestTime: 'उदा. हिवाळ्यात सकाळी, हरित सौंदर्यासाठी पावसाळा',
    placeholderPhotos: 'https://example.com/photo1.jpg',
    submitForReview: 'पुनरावलोकनासाठी सादर करा',
    pendingNote: 'प्रशासक मंजूर करेपर्यंत आपले योगदान प्रलंबित राहील.',
    signInToSeeMine: 'आपली सादरे पाहण्यासाठी साइन इन करा.',
    noMineYet: 'आपण अद्याप काही सादर केलेले नाही.',
    contributor: 'योगदानकर्ता',
    difficultyLabel: 'अवघडपणा:',
    tipsLabel: 'ट्रेकर्ससाठी टिपा:',
    reasonLabel: 'कारण:',
    difficultyEasy: 'सोपे',
    difficultyMedium: 'मध्यम',
    difficultyHard: 'कठीण',
    difficultyExpert: 'तज्ज्ञ',
    statusApproved: 'मंजूर',
    statusPending: 'प्रलंबित',
    statusRejected: 'नाकारले',
  },
  adminFeatures: {
    sections: {
      overview: 'विहंगावलोकन',
      creators: 'निर्माता सूची',
      content: 'सामग्री व्यवस्थापन',
      moderation: 'मॉडरेशन',
      reference: 'संदर्भ डेटा',
      system: 'सिस्टम',
    },
    status: { live: 'सक्रिय', partial: 'अर्धवट', planned: 'नियोजित' },
    ops: {
      view: 'पहा', create: 'जोडा', update: 'संपादन', delete: 'हटवा',
      approve: 'मंजूर', reject: 'नाकार', moderate: 'मॉडरेट',
    },
    open: 'उघडा',
    capabilities: {
      title: 'प्रशासक सुविधा',
      desc: 'सर्व admin सुविधा, स्थिती आणि उपलब्ध क्रिया.',
    },
    dashboard: { desc: 'आकडevadhi आणि द्रुत दuvha.' },
    contentHub: { desc: 'गड, मंदिरे, ब्लॉग आणि मीडिया.' },
    forts: { title: 'गड व्यवस्थापन', desc: 'गड CRUD आणि चित्रे.' },
    temples: { title: 'मंदिर व्यवस्थापन', desc: 'मंदिर CRUD आणि कव्हर चित्र.' },
    wadas: { title: 'वाडे', desc: 'ऐतिहासिक वाडे /wades वर.' },
    historicInfo: { title: 'ऐतिहासिक माहिती', desc: 'इतिहास लेख आणि कथा.' },
    organizations: { desc: 'संस्था, सदस्य, कार्यक्रम, गॅलरी — आणि संस्था प्रतिनिधी स्व-सेवा पोर्टल.' },
    eventModeration: { title: 'कार्यक्रम मंजुरी', desc: 'सार्वजनिक कार्यक्रम सादर मंजूर किंवा नाकार.' },
    thematicRoutes: { title: 'विषयक मार्ग', desc: 'शिवराय मार्ग, कोकण किनारा — वारसा प्रवास मार्ग व्यवस्थापन.' },
    orgCategories: { title: 'संस्था श्रेणी', desc: 'संस्था प्रकार श्रेणी.' },
    dailyHistory: { desc: 'आजचा इतिहास घटना.' },
    weapons: { desc: 'शस्त्र माहिती आणि चित्रे.' },
    shop: { title: 'वारसा दुकान', desc: '/shop साठी उत्पादने, दर, स्टॉक आणि कॅटलॉग.' },
    education: { title: 'वारसा शिक्षण', desc: 'अभ्यासक्रम, धडे, नोट्स, कार्यपत्रिका, ऑडिओबुक आणि कालरेषा.' },
    books: { title: 'वारसा पुस्तके', desc: 'PDF लायbrary — कव्हर अपलोड, /books साठी मोफत ऑनलाइन पुस्तके.' },
    weaponCategories: { title: 'शस्त्र श्रेणी', desc: 'शस्त्र गट श्रेणी.' },
    fortTrekGuide: { title: 'गड ट्रेक मार्गदर्शक', desc: 'प्रत्येक गडासाठी ट्रेक माहिती.' },
    media: { desc: 'मीडिया लायbrary.' },
    blogs: { desc: 'ब्लॉग मॉडरेशन.' },
    contributions: { desc: 'योगदान मंजुरी.' },
    visitBookings: { title: 'गड भेट तिकीट', desc: 'बुकिंग यादी, रद्द, ईमेल/SMS पुन्हा पाठवा.' },
    sardars: { title: 'सरदार', desc: 'वारसा सरदार — चरित्र, युद्ध, गाव, गड जोड/संपादन.' },
    photos: { title: 'फोटो मॉडरेशन', desc: 'प्रलंबित गड फोटो.' },
    contentReview: { title: 'सामग्री review', desc: 'प्रलंबित योगदान, फोटो, ब्लॉग, कार्यक्रम आणि creator सूची — एकाच inbox मध्ये.' },
    users: { desc: 'नोंदणीकृत वापरकर्ते, भूमिका पहा, जोडा, संपादित करा आणि हटवा.' },
    analytics: { desc: 'डेटाबेस आणि सर्व्हर runtime वरून थेट प्लॅटफॉर्म metrics.' },
    site: { desc: 'Site branding, hero, contact, SEO metadata.' },
    community: { desc: 'Moderation hub — contributions, photos, blogs, reviews, policy.' },
    language: { title: 'भाषा', desc: 'Translation (नियोजit).' },
    settings: { desc: 'Platform toggles, registration, language, upload limits.' },
    planned: {
      title: 'अद्याप पurnpan wired नाही',
      desc: 'Admin hakk define kele, pan backend/UI urlele aahe.',
      status: 'स्थिती',
      operations: 'नियोजit kriya',
      noBackend: 'Admin API nahi — backend lagel.',
      viewAll: 'Sarv admin suvidha paha',
      details: 'Tapshil',
    },
  },
  admin: {
    dashboard: 'डॅशबोर्ड',
    users: 'वापरकर्ते',
    blogs: 'ब्लॉग',
    content: 'सामग्री',
    site: 'साइट',
    media: 'माध्यम',
    analytics: 'विश्लेषण',
    community: 'समुदाय',
    settings: 'सेटिंग्ज',
    review: 'पुनरावलोकन',
    language: 'भाषा',
    upload: 'अपलोड',
    contributions: 'योगदान',
    accessDenied: 'प्रशासक प्रवेश आवश्यक',
    signInPrompt: 'कृपया प्रशासक खात्याने साइन इन करा.',
  },
  adminAnalytics: {
    refresh: 'रिफ्रेश',
    lastUpdated: 'शेवटचे अद्यतन',
    lastChecked: 'शेवटची तपासणी',
    tabs: {
      overview: 'विहंगावलोकन',
      content: 'सामग्री',
      engagement: 'सहभाग',
      system: 'सिस्टम',
    },
    sections: {
      contentMix: 'सामग्री मिश्रण',
      catalog: 'Catalog एकूण',
      publishedContent: 'प्रकाशित सामग्री',
      mediaLibrary: 'मीडिया लायब्ररी',
      users: 'वापरकर्ते आणि क्रियाकलाप',
      contributions: 'योगदान',
      runtime: 'सर्व्हर runtime',
      healthNote: 'या metrics बद्दल',
    },
    metrics: {
      users: 'नोंदणीकृत वापरकर्ते',
      adminsHint: '{{count}} प्रशासक',
      forts: 'गड',
      temples: 'मंदिरे',
      blogs: 'ब्लॉग',
      reviews: 'गड review',
      media: 'मीडिया',
      trekPlans: 'ट्रेक योजना',
      pending: 'प्रलंबित योगदान',
      pendingHint: '{{photos}} फोटो moderation साठी',
      wadas: 'वाडे',
      organizations: 'संस्था',
      weapons: 'शस्त्रे',
      historicArticles: 'ऐतिहासिक लेख',
      dailyHistory: 'दैनिक इतिहास',
      contributions: 'योगदान',
      mediaAssets: 'मीडिया फाइल',
      mediaStorage: 'एकूण storage',
      imageAssets: 'चित्रे',
      videoAssets: 'व्हिडिओ',
      approvedPhotos: 'मंजूर गड फोटो',
      pendingPhotos: 'प्रलंबित गड फोटो',
      registeredUsers: 'नोंदणीकृत वापरकर्ते',
      adminUsers: 'प्रशासक खाती',
      visitsLogged: 'भेट नोंदी',
      favoritesSaved: 'आवडते जतन',
      contributionsTotal: 'एकूण सादर',
      contributionsPending: 'प्रलंबित',
      contributionsApproved: 'मंजूर',
      contributionsRejected: 'नाकारले',
      status: 'स्थिती',
      uptime: 'Uptime',
      memoryUsed: 'वापरलेली memory',
      memoryMax: 'कमाल memory',
      memoryUsage: 'Heap वापर',
      dbRecords: 'मुख्य DB records',
    },
    note: {
      engagement: 'Review, भेट, favorites, योगदान आणि trek नोंदींवर आधारित.',
      system: 'Runtime metrics Spring Boot JVM कडून. Visitor traffic नाही.',
      traffic: 'Visitor traffic, page views आणि search analytics अद्याप track होत नाहीत. हे dashboard DB मधील वास्तविक catalog आणि engagement data दाखवते.',
    },
    empty: { content: 'अद्याप catalog सामग्री नाही.' },
    errors: {
      load: 'Analytics लोड अयशस्वी.',
      forbidden: 'प्रशासक प्रवेश आवश्यक.',
    },
  },
  adminSite: {
    refresh: 'रिफ्रेश',
    save: 'जतन करा',
    saving: 'जतन होत आहे…',
    saved: 'Site settings जतन झाले.',
    sections: { brand: 'Brand & hero', contact: 'Contact & social', emergency: 'आपत्कालीन हॉटलाइन', seo: 'SEO & footer' },
    fields: {
      name: 'Site नाव',
      tagline: 'Tagline',
      heroTitle: 'Hero शीर्षक',
      heroSubtitle: 'Hero उपशीर्षक',
      contactEmail: 'Contact email',
      contactPhone: 'मुख्य संपर्क फोन',
      contactLocation: 'Location',
      emergencyHelpline: 'पोर्टल आपत्कालीन हॉटलाइन',
      rescueHelpline: 'बचाव समन्वय हॉटलाइन',
      nationalEmergency: 'राष्ट्रीय आपत्कालीन क्रमांक',
      socialHandle: 'Social handle',
      metaDescription: 'Meta description',
      footerNotice: 'Footer notice',
    },
    hints: {
      emergency: '/emergency आणि Contact पृष्ठावर दर्शवले जाते. देशकोडासह फोन नंबर भरा.',
    },
    errors: { load: 'Site settings लोड अयशस्वी.', save: 'Site settings जतन अयशस्वी.' },
  },
  adminContentReview: {
    title: 'सामग्री review रांg',
    subtitle: 'सर्व प्रलंबित user सबमिशन एकाच ठिकाणahun मंजूर किंवा नाकारा.',
    refresh: 'रिफ्रेश',
    approve: 'मंजूर',
    reject: 'नाकार',
    confirmReject: 'नकार निश्चित करा',
    cancel: 'रद्द',
    openTool: 'साधन उघडा',
    empty: 'review साठी काहीही नाही — सर्व clear आहे.',
    confirmRejectAction: 'हे सबमिशन नाकारायचे?',
    rejectNotePlaceholder: 'सबमिटरसाठी ऐच्छिक टिप (कार्यक्रम आणि creator सूची)',
    manageDeep: 'अधिक तपशील हवा? समर्पित moderation screens उघडा:',
    filters: {
      all: 'सर्व प्रलंबित',
      contribution: 'योगदान',
      photo: 'फोटो',
      blog: 'ब्लॉग',
      event: 'कार्यक्रम',
      creator: 'Creator सूची',
    },
    types: {
      contribution: 'योगदान',
      photo: 'फोटो',
      blog: 'ब्लॉग',
      event: 'कार्यक्रम',
      creator: 'Creator सूची',
    },
    errors: {
      load: 'review रांg लोड करता आली नाही.',
      action: 'कृती अयशस्वी. पुन्हा प्रयत्न करा किंवा समर्पित admin screen वापरा.',
    },
  },
  adminEducation: {
    title: 'वारसा शिक्षण व्यवस्थापन',
    subtitle: 'अभ्यासक्रम, धडे, थोडक्यात नोट्स, कार्यपत्रिका, ऑडिओबुक, कालरेषा आणि शाळा-महाविद्यालय भेट विनंत्या — JSON नको, फक्त फॉर्म.',
    refresh: 'रिफ्रेश',
    save: 'सामग्री जतन करा',
    create: 'नवीन',
    edit: 'संपादन',
    add: '{{type}} जोडा',
    confirmArchive: '“{{title}}” संग्रहित करायचे?',
    tabs: { content: 'शिक्षण सामग्री', visits: 'संस्था भेट विनंत्या ({{count}})' },
    types: {
      learningPath: 'अभ्यासक्रम',
      lesson: 'धडे',
      shortNote: 'थोडक्यात नोट्स',
      worksheet: 'कार्यपत्रिका',
      audiobook: 'ऑडिओबुक',
      timelineEvent: 'कालरेषा घटना',
    },
    table: { title: 'शीर्षक', category: 'वर्ग', order: 'क्रम', status: 'स्थिती', actions: 'कृती' },
    status: { active: 'प्रकाशित', draft: 'मसुदा' },
    badges: { mp3Ready: 'MP3 तयार', noMp3: 'MP3 नाही', fileReady: 'फाईल तयार', noFile: 'फाईल नाही' },
    empty: 'अद्याप {{type}} नाहीत.',
    visitStatus: {
      PENDING: 'प्रलंबित',
      CONTACTED: 'संपर्क केला',
      APPROVED: 'मंजूर',
      REJECTED: 'नाकारले',
      COMPLETED: 'पूर्ण',
    },
    visits: {
      empty: 'अद्याप संस्था भेट विनंत्या नाहीत.',
      anyFort: 'कोणताही गड',
      flexibleDate: 'तारीख लवचिक',
      students: '{{count}} विद्यार्थी',
    },
    eventKinds: {
      BATTLE: 'लढाई',
      CORONATION: 'राज्याभिषेक',
      FORT_CAPTURE: 'गड जिंकला',
      BIRTH: 'जन्म / उगम',
      OTHER: 'इतर',
    },
    form: {
      titleEn: 'इंग्रजी शीर्षक *',
      titleMr: 'मराठी शीर्षक',
      descriptionEn: 'इंग्रजी वर्णन',
      descriptionMr: 'मराठी वर्णन',
      learningPath: 'अभ्यासक्रम *',
      selectPath: 'अभ्यासक्रम निवडा',
      year: 'वर्ष',
      eventKind: 'घटना प्रकार',
      selectEventKind: 'प्रकार निवडा',
      fort: 'संबंधित गड',
      selectFort: 'गड निवडा (ऐच्छिक)',
      category: 'वर्ग',
      categoryPlaceholder: 'इतिहास, MPSC, स्थापत्य…',
      audience: 'प्रेक्षक',
      audiencePlaceholder: 'विद्यार्थी, MPSC, इयत्ता ६–१०…',
      duration: 'कालावधी (मिनिटे)',
      sortOrder: 'प्रदर्शन क्रम',
      structuredEn: 'इंग्रजी सामग्री (फॉर्म)',
      structuredMr: 'मराठी सामग्री (फॉर्म)',
      keyPoints: 'महत्त्वाचे मुद्दे',
      addPoint: 'मुद्दा जोडा',
      keyPointPlaceholder: 'एक शिकण्याचा मुद्दा',
      examTips: 'परीक्षा टिप्स',
      addExamTip: 'टिप जोडा',
      examTip: 'परीक्षा टिप',
      examTipPlaceholder: 'उजळणी किंवा परीक्षा सल्ला',
      activity: 'वर्ग क्रियाकलाप (ऐच्छिक)',
      activityPlaceholder: 'विद्यार्थ्यांसाठी सराव',
      quiz: 'प्रश्नमंजुषा (ऐच्छिक)',
      quizEmpty: 'अद्याप प्रश्न नाहीत.',
      question: 'प्रश्न',
      answer: 'उत्तर',
      addQuiz: 'प्रश्न जोडा',
      worksheetSections: 'कार्यपत्रिका विभाग / कामे',
      addSection: 'विभाग जोडा',
      sectionPlaceholder: 'उदा. गडाच्या दरवाजाचा आराखडा काढा',
      chapters: 'प्रकरण यादी (इंग्रजी)',
      chaptersMr: 'प्रकरण यादी (मराठी)',
      chapterNumber: 'प्रकरण {{n}}',
      chapterTitle: 'प्रकरण शीर्षक',
      chapterText: 'कथन मजकूर (ऐच्छिक — ऑडिओ फाईलच ऐकण्यासाठी)',
      addChapter: 'प्रकरण जोडा',
      audioFile: 'MP3 ऑडिओ फाईल *',
      worksheetFile: 'कार्यपत्रिका PDF/DOC *',
      audioPlaceholder: 'MP3 अपलोड करा किंवा URL',
      worksheetPlaceholder: 'PDF/DOC अपलोड करा किंवा URL',
      uploadMp3: 'MP3 अपलोड',
      uploadDoc: 'PDF/DOC अपलोड',
      audioHint: 'प्रकाशनापूर्वी MP3 आवश्यक. मसुद्यासाठी ऑडिओ नसतो तरी चालेल.',
      worksheetHint: 'प्रकाशनापूर्वी PDF/Word आवश्यक. मसुद्यासाठी फाईल नसतो तरी चालेल.',
      previewWorksheet: 'कार्यपत्रिका पहा',
      published: 'साइटवर प्रकाशित आणि दृश्य',
      uploadMp3First: 'प्रथम MP3 अपलोड करा',
      uploadDocFirst: 'प्रथम फाईल अपलोड करा',
    },
    errors: {
      load: 'शिक्षण डेटा लोड अयशस्वी.',
      save: 'सामग्री जतन अयशस्वी.',
      archive: 'संग्रह अयशस्वी.',
      upload: 'फाईल अपलोड अयशस्वी.',
      visit: 'भेट स्थिती अद्यतन अयशस्वी.',
      audiobookFile: 'प्रकाशित ऑडिओबुकसाठी MP3 आवश्यक.',
      worksheetFile: 'प्रकाशित कार्यपत्रिकेसाठी PDF/DOC आवश्यक.',
      mp3Only: 'ऑडिओबुक फक्त .mp3 स्वीकारते.',
      docOnly: 'कार्यपत्रिका .pdf, .doc, .docx स्वीकारते.',
    },
  },
  adminSettings: {
    refresh: 'रिफ्रेश',
    save: 'जतन करा',
    saving: 'जतन होत आहे…',
    saved: 'System settings जतन झाले.',
    maintenanceWarning: 'Maintenance mode सुरू आहे.',
    sections: { platform: 'Platform controls', defaults: 'Defaults & limits' },
    fields: {
      maintenanceMode: 'Maintenance mode',
      registrationEnabled: 'नवीन registration',
      publicSearchEnabled: 'Public search',
      defaultLanguage: 'Default language',
      maxUploadMb: 'Max upload (MB)',
      supportEmail: 'Support email',
    },
    hints: {
      maintenanceMode: 'Site maintenance दर्शवते.',
      registrationEnabled: 'नवीन खाती तयार करण्याची परवानगी.',
      publicSearchEnabled: 'Search API public access.',
    },
    errors: { load: 'System settings लोड अयशस्वी.', save: 'System settings जतन अयशस्वी.' },
  },
  adminCommunity: {
    refresh: 'रिफ्रेश',
    approve: 'मंजूर',
    reject: 'नाकार',
    savePolicy: 'Policy जतन',
    policySaved: 'Community policy जतन झाली.',
    quickLinks: 'Admin pages',
    confirmReject: 'हे contribution नाकारायचे?',
    confirmDeletePhoto: 'हा photo हटवायचा?',
    confirmDeleteReview: 'हा review कायमचा हटवायचा?',
    tabs: {
      overview: 'विहंगावलोकन',
      contributions: 'योगदान',
      photos: 'फोटो',
      blogs: 'ब्लॉग',
      reviews: 'Reviews',
      policy: 'Policy',
    },
    stats: {
      contributions: 'प्रलंबित योगदान',
      photos: 'प्रलंबित फोटो',
      blogs: 'प्रलंबित ब्लॉग',
      reviews: 'एकूण reviews',
    },
    columns: {
      fort: 'गड',
      user: 'वापरकर्ता',
      rating: 'Rating',
      comment: 'Comment',
      date: 'तारीख',
      actions: 'क्रिया',
    },
    fields: {
      guidelines: 'Community guidelines',
      moderationEnabled: 'Moderation आवश्यक',
      autoApproveContributions: 'Auto-approve contributions',
      allowPhotoUploads: 'Photo uploads',
      allowReviews: 'Fort reviews',
    },
    empty: {
      creators: 'निर्माता सूची उपलब्ध नाही.',
      contributions: 'प्रलंबित योगदान नाहीत.',
      photos: 'प्रलंबित फोटो नाहीत.',
      blogs: 'प्रलंबित ब्लॉग नाहीत.',
      reviews: 'Reviews नाहीत.',
    },
    errors: {
      load: 'Community data लोड अयशस्वी.',
      save: 'Policy जतन अयशस्वी.',
      action: 'क्रिया अयशस्वी.',
      forbidden: 'प्रशासक प्रवेश आवश्यक.',
    },
  },
  adminUsers: {
    refresh: 'रिफ्रेश',
    addUser: 'वापरकर्ता जोडा',
    editUser: 'वापरकर्ता संपादित करा',
    edit: 'संपादन',
    delete: 'हटवा',
    save: 'जतन करा',
    saving: 'जतन होत आहे…',
    cancel: 'रद्द',
    empty: 'कोणतेही वापरकर्ते सापडले नाहीत.',
    searchPlaceholder: 'नाव किंवा ईमेल शोधा…',
    allRoles: 'सर्व भूमिका',
    confirmDelete: 'वापरकर्ता "{{name}}" हटवायचा? हे पूर्ववत करता येणार नाही.',
    stats: { total: 'यादीतले वापरकर्ते', admins: 'प्रशासक' },
    columns: {
      name: 'नाव',
      email: 'ईमेल',
      role: 'भूमिका',
      organization: 'संस्था',
      joined: 'नोंदणी',
      actions: 'क्रिया',
    },
    fields: {
      fullName: 'पूर्ण नाव',
      email: 'ईमेल',
      role: 'भूमिका',
      organization: 'जोडलेली संस्था',
      password: 'पासवर्ड',
      passwordOptional: 'नवीन पासवर्ड (रिकामे = जुना ठेवा)',
    },
    selectOrganization: 'संस्था निवडा…',
    errors: {
      load: 'वापरकर्ते लोड करण्यात अयशस्वी.',
      save: 'वापरकर्ता जतन करण्यात अयशस्वी.',
      delete: 'वापरकर्ता हटवण्यात अयशस्वी.',
      forbidden: 'प्रशासक प्रवेश आवश्यक.',
      required: 'नाव आणि ईमेल आवश्यक.',
      password: 'पासवर्ड किमान ८ अक्षरे असावा.',
      organizationRequired: 'ORG_REP वापरकर्त्याला संस्थेशी जोडलेले असणे आवश्यक.',
    },
  },
  orgPortal: {
    seoTitle: 'माझी संस्था व्यवस्थापित करा',
    seoDesc: 'संस्था प्रोफाइल अद्यतनित करा, मंजुरीसाठी कार्यक्रम सादर करा, गॅलरी आणि कार्यसंघ व्यवस्थापित करा.',
    badge: 'संस्था प्रतिनिधी पोर्टल',
    subtitle: 'सार्वजनिक प्रोफाइल संपादित करा आणि प्रशासक मंजुरीसाठी कार्यक्रम सादर करा.',
    refresh: 'रिफ्रेश',
    loading: 'संस्था पोर्टल लोड होत आहे…',
    backToOrgs: 'संस्थांकडे परत',
    viewPublic: 'सार्वजनिक पान पहा',
    accessDenied: 'संस्था पोर्टल प्रवेश आवश्यक',
    accessDeniedDesc: 'हे क्षेत्र प्रशासकाने नियुक्त केलेल्या संस्था प्रतिनिधींसाठी आहे.',
    profileHint: 'प्रोफाइल बदल प्रकाशित झाल्यावर सार्वजनिक पानावर दिसतील. श्रेणी आणि मंजुरी प्रशासक व्यवस्थापित करतात.',
    eventsHint: 'सादर केलेले कार्यक्रम प्रशासक मंजूर करेपर्यंत प्रलंबित राहतात.',
    saveProfile: 'प्रोफाइल जतन करा',
    profileSaved: 'प्रोफाइल जतन झाली.',
    submitEvent: 'मंजुरीसाठी सादर करा',
    eventSubmitted: 'कार्यक्रम प्रशासक मंजुरीसाठी सादर झाला.',
    noEvents: 'अद्याप कोणतेही कार्यक्रम नाहीत.',
    confirmDeleteEvent: 'हा प्रलंबित कार्यक्रम हटवायचा?',
    deletePending: 'प्रलंबित हटवा',
    reviewNote: 'प्रशासक टीप',
    addGallery: 'फोटो जोडा',
    galleryAdded: 'फोटो जोडला.',
    addMember: 'कार्यसंघ सदस्य जोडा',
    memberAdded: 'सदस्य जोडला.',
    addDocument: 'दस्तऐवज जोडा',
    documentAdded: 'दस्तऐवज जोडला.',
    viewDocument: 'फाईल पहा',
    upload: 'अपलोड',
    categoryDetails: 'श्रेणी-विशिष्ट तपशील',
    tabs: {
      profile: 'प्रोफाइल',
      events: 'कार्यक्रम',
      gallery: 'गॅलरी',
      team: 'कार्यसंघ',
      documents: 'दस्तऐवज',
    },
    fields: {
      name: 'संस्थेचे नाव',
      slug: 'URL slug',
      establishedYear: 'स्थापना वर्ष',
      shortDescription: 'थोडक्यात वर्णन',
      fullDescription: 'संपूर्ण वर्णन',
      logo: 'लोगो URL',
      coverImage: 'कव्हर प्रतिमा URL',
      email: 'संपर्क ईमेल',
      mobile: 'मोबाइल',
      whatsapp: 'WhatsApp',
      website: 'वेबसाइट',
      district: 'जिल्हा',
      city: 'शहर',
      address: 'पत्ता',
      eventTitle: 'कार्यक्रम शीर्षक',
      eventDate: 'दिनांक',
      eventLocation: 'स्थळ',
      eventDescription: 'वर्णन',
      paidEvent: 'सशुल्क / तिकीट कार्यक्रम',
      priceInr: 'किंमत (₹)',
      maxSeats: 'जागा',
      registrationUrl: 'नोंदणी URL',
      imageUrl: 'प्रतिमा URL',
      caption: 'शीर्षक',
      memberName: 'नाव',
      memberRole: 'भूमिका',
      memberEmail: 'ईमेल',
      memberMobile: 'मोबाइल',
      docTitle: 'शीर्षक',
      docType: 'प्रकार',
      docUrl: 'फाईल URL',
    },
    errors: {
      load: 'संस्था पोर्टल लोड होऊ शकला नाही.',
      save: 'प्रोफाइल जतन अयशस्वी.',
      event: 'कार्यक्रम क्रिया अयशस्वी.',
      gallery: 'गॅलरी क्रिया अयशस्वी.',
      member: 'कार्यसंघ क्रिया अयशस्वी.',
      document: 'दस्तऐवज क्रिया अयशस्वी.',
      upload: 'अपलोड अयशस्वी.',
    },
  },
  about: {
    heritageBadge: 'गडकोट • वारसा • महाराष्ट्र',
    heroSubtitle: 'भारताच्या भव्य ऐतिहासिक वारसाचे आपले डिजिटल द्वार',
    startExploring: 'शोध सुरू करा',
    discoverRoutes: 'गड आणि मंदिरे',
    whatSectionSubtitle: 'आमच्या संपूर्ण डिजिटल वारसा प्लॅटफॉर्माची ओळख',
    digitalPlatformTitle: 'डिजिटल वारसा प्लॅटफॉर्म',
    digitalPlatformDesc:
      'गडकोट हे भारताच्या समृद्ध ऐतिहासिक वारसाचे जतन, दस्तऐवजीकरण आणि सामायिकरणासाठी समर्पित एक संपूर्ण डिजिटल व्यासपीठ आहे. देशभरातील गड, मंदिरे, स्मारके आणि सांस्कृतिक स्थळांबद्दल आम्ही सविस्तर माहिती पुरवतो.',
    featureMaps: 'संवादात्मक नकाशे आणि आभासी सफर',
    featureHistory: 'ऐतिहासिक माहिती आणि कथा',
    featureAudio: 'ऑडिओ मार्गदर्शक आणि मल्टिमीडिया सामग्री',
    primaryGoalsTitle: 'आमची प्राथमिक ध्येये',
    primaryGoalsDesc:
      'ऐतिहासिक स्थळे आणि आधुनिक प्रेक्षक यांच्यातील अंतर भरून काढणे — वारसाला सर्वांसाठी सुलभ, आकर्षक आणि शैक्षणिक बनवणे.',
    goalDemocratize: 'ऐतिहासिक ज्ञानात प्रवेश सर्वांसाठी',
    goalPreserve: 'डिजिटल माध्यमातून सांस्कृतिक वारसाचे जतन',
    goalInspire: 'वारसा शोध आणि पर्यटनाला प्रेरणा',
    whoWeServeTitle: 'आम्ही कोणासाठी काम करतो',
    whoWeServeDesc:
      'इतिहासप्रेमी, प्रवासी, विद्यार्थी ते संशोधक — विविध प्रेक्षकांसाठी आमचे व्यासपीठ तयार केले आहे.',
    audienceResearchers: 'इतिहास उत्साही आणि संशोधक',
    audienceStudents: 'विद्यार्थी आणि शैक्षणिक संस्था',
    audienceTravelers: 'प्रवासी आणि सांस्कृतिक पर्यटक',
    storyP1:
      'गडकोटची सुरुवात एका साध्या परंतु प्रभावी दृष्टिकोनातून झाली: भारताचा समृद्ध ऐतिहासिक वारसा जगातील कोणत्याही कोपऱ्यातून सुलभ करणे. इतिहासप्रेमींनी स्थापन केलेले हे व्यासपीठ ऐतिहासिक शोधासाठी एक संपूर्ण डिजिटल साधन म्हणून विकसित होत आहे.',
    storyP2:
      'बहुतेक ऑनलाइन स्रोत खूप शैक्षणिक किंवा खूप सैल होते. आम्हाला शिक्षण आणि रंजन यांचा समतोल, प्रामाणिक आणि सुलभ असा अनुभव हवा होता.',
    storyP3:
      'आज गडकोट गड, मंदिरे आणि स्मारके यांची सविस्तर माहिती, आभासी सफर, ऑडिओ मार्गदर्शक आणि संवादात्मक नकाशे यासह भारताच्या ऐतिहासिक स्थळांचा शोध करण्याचे व्यासपीठ बनण्याच्या मार्गावर आहे.',
    statFounded: 'स्थापना',
    statFocus: 'आमचा फोकस',
    statApproach: 'आमचा दृष्टिकोन',
    statFocusValue: 'इतिहास',
    statApproachValue: 'डिजिटल',
    storyImageAlt: 'वारसा संवर्धनावर काम करणारी टीम',
    missionBadge: 'ध्येय: इतिहास जपा',
    missionVisionSubtitle: 'आमच्या डिजिटल वारसा व्यासपीठाला दिशा देणारी तत्त्वे',
    missionFullDesc:
      'नावीन्यपूर्ण डिजिटल अनुभवांद्वारे भारताच्या ऐतिहासिक वारसाला लोकशाही बनवणे — शिक्षित करणे, प्रेरणा देणे आणि सांस्कृतिक वारसाशी जोडणे.',
    missionPoint1: 'ऐतिहासिक शोध सर्वांसाठी सुलभ',
    missionPoint2: 'आकर्षक आणि शैक्षणिक सामग्री',
    missionPoint3: 'डिजिटल नावीन्याने वारसाचे जतन',
    visionFullDesc:
      'ऐतिहासिक शोधासाठी जगातील सर्वात विश्वासार्ह आणि संपूर्ण डिजिटल व्यासपीठ बनणे, जिथे प्रत्येकजण शोध, शिकणे आणि योगदान देऊ शकेल.',
    visionPoint1: 'वारसा संवर्धनासाठी जागतिक ओळख',
    visionPoint2: 'समुदाय-चालित दस्तऐवजीकरण',
    visionPoint3: 'तंत्रज्ञान-आधारित सांस्कृतिक शिक्षण',
    valuesSubtitle: 'गडकोटवरील प्रत्येक कामाला दिशा देणारी तत्त्वे',
    valuePreservationTitle: 'प्रथम जतन',
    valuePreservationDesc: 'भावी पिढ्यांसाठी भारताचा सांस्कृतिक वारसा जपणे आणि प्रमोट करणे.',
    valueCommunityTitle: 'समुदाय-केंद्रित',
    valueCommunityDesc: 'तज्ज्ञ आणि वापरकर्त्यांच्या योगदानाने बांधलेले व्यासपीठ.',
    valueAccessibleTitle: 'सर्वांसाठी सुलभ',
    valueAccessibleDesc: 'प्रत्येकाला ऐतिहासिक स्थळे शिकण्याची आणि शोधण्याची संधी.',
    valueInnovationTitle: 'नावीन्यावर भर',
    valueInnovationDesc: 'इमर्सिव्ह आणि शैक्षणिक अनुभवांसाठी तंत्रज्ञानाचा वापर.',
    valueAuthenticTitle: 'प्रामाणिक सामग्री',
    valueAuthenticDesc: 'संशोधित आणि तज्ज्ञांकडून पडताळलेली माहिती.',
    valueUxTitle: 'वापरकर्ता अनुभव',
    valueUxDesc: 'सहज, आकर्षक आणि माहितीपूर्ण अनुभव.',
    platformFocusTitle: 'आमच्या व्यासपीठाचा फोकस',
    platformFocusSubtitle: 'ऐतिहासिक संवर्धनाच्या आमच्या मुख्य तत्त्वांवर भर',
    focusHistoricalTitle: 'ऐतिहासिक फोकस',
    focusHistoricalDesc: 'भारताच्या समृद्ध ऐतिहासिक वारसाचे जतन आणि सामायिकरण',
    focusEducationalTitle: 'शैक्षणिक सामग्री',
    focusEducationalDesc: 'शिकण्यासाठी आणि शोधासाठी संपूर्ण ऐतिहासिक साधने',
    focusDigitalTitle: 'डिजिटल जतन',
    focusDigitalDesc: 'सांस्कृतिक वारसाचे दस्तऐवजीकरण तंत्रज्ञानाने',
    focusMissionTitle: 'ध्येय-संचालित',
    focusMissionDesc: 'इतिहास सर्वांसाठी सुलभ आणि आकर्षक बनवणे',
    partnersTitle: 'आमचे भागीदार',
    partnersSubtitle: 'वारसा संवर्धनासाठी प्रतिबद्ध संस्था',
    partnerAsi: 'भारतीय पुरातत्त्व सर्वेक्षण',
    partnerAsiType: 'सरकारी',
    partnerMahaTourism: 'महाराष्ट्र पर्यटन',
    partnerMahaTourismType: 'पर्यटन मंडळ',
    partnerHeritageTrust: 'वारसा ट्रस्ट',
    partnerHeritageTrustType: 'एनजीओ',
    partnerDigitalMuseum: 'डिजिटल संग्रहालय उपक्रम',
    partnerDigitalMuseumType: 'सांस्कृतिक',
    ctaTitle: 'आमच्या ऐतिहासिक प्रवासात सामील व्हा',
    ctaDesc:
      'भारताचा ऐतिहासिक वारसा जपणे आणि सामायिक करण्याच्या आमच्या मिशनची सुरुवात आहे. इतिहासप्रेमी, संशोधक किंवा उत्सुक — आमच्यासोबत शोधा आणि वाढा.',
    getInTouch: 'संपर्क साधा',
    seoTitle: 'गडकोट बद्दल — भारताचा ऐतिहासिक वारसा',
    seoDescription:
      'गडकोटचे ध्येय, दृष्टिकोन आणि मूल्ये — डिजिटल माध्यमातून भारताचा ऐतिहासिक वारसा जपणे आणि प्रसार.',
  },
  thematicRoutes: {
    heritageBadge: 'निवडक मार्ग • गड • वारसा',
    routesCountLabel: 'विषयक मार्ग',
    overviewSiteCount: '{{count}} ठिकाणे',
    routeNotFound: 'मार्ग सापडला नाही',
    routeNotFoundHint: 'विनंती केलेला विषयक मार्ग अस्तित्वात नाही.',
    pageTitle: 'विषयक मार्ग',
    pageSubtitle: 'महाराष्ट्राच्या ऐतिहासिक वारसातून निवडक प्रवास — गड, मंदिरे आणि संस्कृती एकाच मार्गात',
    searchPlaceholder: 'मार्ग, ठिकाण किंवा अनुभव शोधा...',
    durationAll: 'सर्व कालावधी',
    durationShort: '२–५ दिवस',
    durationMedium: '५–८ दिवस',
    durationLong: '८+ दिवस',
    routesFound: 'मार्ग सापडले',
    durationLabel: 'कालावधी',
    bestTimeLabel: 'सर्वोत्तम काळ',
    sitesLabel: 'ठिकाणे',
    destinations: 'गंतव्ये',
    viewRoute: 'मार्ग पहा',
    highlights: 'मार्गाची ठळक वैशिष्ट्ये',
    experiences: 'अनुभव',
    overview: 'विषयक मार्ग — आढावा',
    overviewDesc: 'गडकोटवर उपलब्ध निवडक प्रवास मार्ग — प्रत्येक मार्ग महाराष्ट्राच्या वेगळ्या ऐतिहासिक थीमवर आधारित आहे.',
    noRoutes: 'कोणतेही मार्ग सापडले नाहीत',
    noRoutesHint: 'शोध शब्द किंवा कालावधी फिल्टर बदलून पहा',
    backToRoutes: 'सर्व मार्गांकडे',
    planTrip: 'ट्रेक नियोजित करा',
    exploreForts: 'सर्व गड पहा',
    difficultyLabel: 'अडचण',
    stopsTitle: 'मार्गावरील ठिकाणे',
    stopFort: 'गड',
    stopTemple: 'मंदिर',
    stopNature: 'निसर्ग',
    seoTitle: 'विषयक मार्ग — महाराष्ट्र वारसा प्रवास | गडकोट',
    seoDescription:
      'शिवराय मार्ग, कोकण किनारपट्टी, पवित्र महाराष्ट्र आणि अधिक — निवडक विषयक प्रवास मार्ग शोधा.',
  },
  emergency: {
    badge: 'सुरक्षा • बचाव • हॉटलाइन',
    title: 'आपत्कालीन व बचाव',
    heroSubtitle: 'राष्ट्रीय आपत्कालीन सेवा, गडकोट हॉटलाइन, गड-विशिष्ट संपर्क आणि नोंदणीकृत बचाव संघ.',
    tapToCall: 'कॉल करण्यासाठी टॅप करा',
    nationalTitle: 'राष्ट्रीय आपत्काल ({{number}})',
    nationalDesc: 'पोलीस, अग्निशमन आणि रुग्णवाहिका — भारत एकीकृत आपत्काल.',
    portalHotline: 'गडकोट आपत्कालीन हॉटलाइन',
    portalHotlineDesc: 'ट्रेक आणि वारसा कार्यक्रमांसाठी पोर्टल-व्यापी समन्वय.',
    rescueHotline: 'बचाव समन्वय',
    rescueHotlineDesc: 'पर्वत / ट्रेक बचाव समन्वय रेषा.',
    fortTrekTitle: 'गड-विशिष्ट आपत्काल',
    fortTrekDesc: 'प्रत्येक गड पृष्ठावर Trek Essentials अंतर्गत स्थानिक पोलीस, रुग्णालय आणि बचाव संपर्क — Admin → Fort trek guides मध्ये जोडा.',
    browseForts: 'गड पहा',
    rescueGroupsTitle: 'नोंदणीकृत बचाव संघ',
    rescueGroupsDesc: 'गडकोटवर सूचीबद्ध आपत्ती व्यवस्थापन आणि बचाव संस्था.',
    viewAllRescueGroups: 'सर्व बचाव संघ पहा',
    noRescueGroups: 'अद्याप बचाव संघ सूचीबद्ध नाहीत. Admin → Organizations (Rescue Groups) मध्ये जोडा.',
    noHotlineListed: '२४×७ क्रमांक नाही — संस्था प्रोफाइल पहा.',
    viewOrgProfile: 'संस्था प्रोफाइल पहा',
    disclaimer: 'जीवघेण्या परिस्थितीत प्रथम राष्ट्रीय आपत्काल क्रमांकावर कॉल करा. गडकोट संदर्भासाठी समुदाय संपर्क सूचीबद्ध करते.',
    seoTitle: 'आपत्कालीन व बचाव | गडकोट',
    seoDescription: 'राष्ट्रीय हॉटलाइन, गडकोट आपत्कालीन क्रमांक, गड ट्रेक संपर्क आणि महाराष्ट्र बचाव संघ निर्देशिका.',
  },
  contact: {
    heritageBadge: 'संपर्क • सहाय्य • वारसा',
    emergencyBannerTitle: 'ट्रेक किंवा वारसा आपत्काल?',
    emergencyBannerDesc: 'राष्ट्रीय हॉटलाइन, गडकोट समन्वय क्रमांक आणि नोंदणीकृत बचाव संघ.',
    emergencyBannerCta: 'आपत्कालीन केंद्र उघडा',
    heroSubtitle:
      'भारताचा समृद्ध वारसा शोधण्यात आम्ही मदत करण्यासाठी येथे आहोत. प्रश्न, अभिप्राय किंवा सहकार्यासाठी संपर्क साधा.',
    emailUs: 'ईमेल करा',
    callUs: 'कॉल करा',
    visitUs: 'भेट द्या',
    emailResponse: 'आम्ही साधारणपणे २४ तासांत उत्तर देतो',
    callHours: 'सोम–शुक्र, सकाळ ९–संध्याकाळ ६ (IST)',
    visitAppointment: 'फक्त अपॉइंटमेंटवर',
    sendMessage: 'आम्हाला संदेश पाठवा',
    messageSent: 'संदेश यशस्वीरीत्या पाठवला!',
    messageSentDesc: 'आम्ही २४ तासांत परत संपर्क करू.',
    submitError: 'संदेश पाठवता आला नाही. पुन्हा प्रयत्न करा किंवा gadkotheritage@gmail.com वर थेट ईमेल करा.',
    formName: 'नाव',
    formEmail: 'ईमेल',
    formSubject: 'विषय',
    formMessage: 'संदेश',
    formSubmit: 'संदेश पाठवा',
    title: 'संपर्क',
    namePlaceholder: 'आपले पूर्ण नाव',
    emailPlaceholder: 'your@email.com',
    category: 'श्रेणी',
    categoryGeneral: 'सामान्य चौकशी',
    categoryTechnical: 'तांत्रिक सहाय्य',
    categoryContent: 'सामग्री योगदान',
    categoryPartnership: 'भागीदारी',
    categoryMedia: 'मीडिया आणि प्रेस',
    subjectPlaceholder: 'हे कशाबद्दल आहे?',
    messagePlaceholder: 'तुमच्या चौकशीबद्दल अधिक सांगा...',
    sending: 'पाठवत आहे...',
    contactDepartments: 'आमच्या विभागांशी संपर्क',
    techDept: 'तांत्रिक सहाय्य',
    techDeptDesc: 'वेबसाइट समस्या, बग किंवा तांत्रिक मदतीसाठी',
    techEmail: 'tech@gadkot.com',
    contentTeam: 'सामग्री टीम',
    contentTeamDesc: 'सामग्री दुरुस्ती, सूचना किंवा योगदानासाठी',
    contentEmail: 'content@gadkot.com',
    partnershipsDept: 'भागीदारी',
    partnershipsDeptDesc: 'सहकार्य आणि भागीदारीच्या संधींसाठी',
    partnershipsEmail: 'partnerships@gadkot.com',
    mediaDept: 'मीडिया आणि प्रेस',
    mediaDeptDesc: 'मीडिया चौकशी आणि प्रेस प्रकाशनासाठी',
    mediaEmail: 'media@gadkot.com',
    mondayFriday: 'सोमवार - शुक्रवार:',
    mondayFridayHours: 'सकाळ ९:०० - संध्याकाळ ६:०० IST',
    saturday: 'शनिवार:',
    saturdayHours: 'सकाळ १०:०० - दुपारी ४:०० IST',
    sunday: 'रविवार:',
    sundayClosed: 'बंद',
    holidays: 'सुट्ट्या:',
    holidaysClosed: 'प्रमुख भारतीय सुट्ट्यांवर बंद',
    ourLocation: 'आमचे स्थान',
    addressLabel: 'पत्ता:',
    addressValue: 'मुंबई, महाराष्ट्र, भारत',
    visitsLabel: 'भेटी:',
    visitsValue: 'फक्त अपॉइंटमेंटवर',
    timezoneLabel: 'वेळ क्षेत्र:',
    timezoneValue: 'भारतीय प्रमाणवेळ (GMT+5:30)',
    pageFaq1Q: 'मला किती लवकर उत्तर मिळेल?',
    pageFaq1A:
      'कार्यदिवसांमध्ये आम्ही साधारणपणे २४ तासांत उत्तर देतो. तांत्रिक समस्या प्राधान्याने ४–६ तासांत सोडवल्या जातात.',
    pageFaq2Q: 'मी गडकोटमध्ये सामग्री योगदान देऊ शकतो का?',
    pageFaq2A:
      'होय! इतिहासप्रेमी, छायाचित्रकार आणि संशोधकांचे योगदान स्वागतार्ह आहे. कृपया आपल्या कल्पना सामग्री टीमशी शेअर करा.',
    pageFaq3Q: 'मार्गदर्शित दौरे किंवा भागीदारी उपलब्ध आहेत का?',
    pageFaq3A:
      'आम्ही स्थानिक मार्गदर्शक आणि वारसा संस्थांशी भागीदारी करतो. सहकार्यासाठी भागीदारी विभागाशी संपर्क साधा.',
    pageFaq4Q: 'त्रुटी कशी नोंदवावी किंवा सुधारणा सुचवावी?',
    pageFaq4A:
      'संपर्क फॉर्म वापरा किंवा tech@gadkot.com वर ईमेल करा. व्यासपीठ सुधारण्यास मदत करणारा अभिप्राय आम्हाला महत्त्वाचा आहे.',
    seoTitle: 'गडकोटशी संपर्क — सहाय्य आणि चौकशी',
    seoDescription:
      'सहाय्य, भागीदारी किंवा सामान्य चौकशीसाठी गडकोटशी संपर्क साधा. ईमेल, फोन आणि कार्यालयीन वेळ पहा.',
  },
  blog: {
    title: 'वारसा ब्लॉग',
    subtitle: 'इतिहासप्रेमी आणि प्रवाशांच्या कथा आणि अनुभव',
    heritageBadge: 'मराठी वारसाच्या कथा',
    themeForts: 'गड',
    themeTemples: 'मंदिरे',
    themeHistory: 'इतिहास',
    themeCulture: 'संस्कृती',
    themeTravel: 'प्रवास',
    allPosts: 'सर्व पोस्ट',
    addBlog: 'ब्लॉग जोडा',
    signInToSubmit: 'ब्लॉग सादर करण्यासाठी साइन इन करा.',
    shareYourStory: 'आपली कथा सामायिक करा',
    titlePlaceholder: 'ब्लॉग शीर्षक प्रविष्ट करा...',
    contentPlaceholder: 'ऐतिहासिक अंतर्दृष्टी, अनुभव किंवा कथा सामायिक करा...',
    tagsPlaceholder: 'इतिहास, गड, मंदिरे, प्रवास...',
    featured: 'वैशिष्ट्यीकृत',
    loadingBlogs: 'ब्लॉग लोड होत आहेत...',
    writeFirstBlog: 'पहिला ब्लॉग लिहा',
    beFirstToShare: 'आपले ऐतिहासिक अंतर्दृष्टी सामायिक करणारे पहिले व्हा!',
    tryAdjustingSearch: 'शोध शब्द बदलून पहा',
    reviewProcessTitle: 'समीक्षा प्रक्रिया',
    reviewProcessDesc:
      'तुमचा ब्लॉग प्रकाशित होण्यापूर्वी प्रशासक टीमद्वारे तपासला जाईल. साधारणपणे २४–४८ तास लागतात.',
    dropImages: 'प्रतिमा येथे ड्रॅग करा किंवा अपलोड करण्यासाठी क्लिक करा',
    chooseImages: 'प्रतिमा निवडा',
    submittedSuccess: 'ब्लॉग समीक्षेसाठी सबमिट झाला! प्रशासक मंजुरीनंतर दिसेल.',
    submitFailed: 'ब्लॉग सबमिट करण्यात अयशस्वी',
    linkCopied: 'दुवा क्लिपबोर्डवर कॉपी झाला!',
    notFound: 'ब्लॉग सापडला नाही',
    notFoundDesc: 'आपण शोधत असलेला ब्लॉग अस्तित्वात नाही.',
    backToBlog: 'ब्लॉगकडे परत',
    loadingBlog: 'ब्लॉग लोड होत आहे...',
    guest: 'अतिथी',
    defaultCategory: 'ब्लॉग',
    categories: {
      forts: 'गड',
      temples: 'मंदिरे',
      historical: 'ऐतिहासिक ठिकाणे',
      culture: 'संस्कृती',
      travel: 'प्रवास',
    },
    articleBody: 'लेख',
    aboutPost: 'या लेखाबद्दल',
    writtenBy: 'लेखक',
    publishedOn: 'प्रकाशित',
    categoryLabel: 'विषय',
    tagsLabel: 'टॅग',
    seoTitle: 'वारसा ब्लॉग — ऐतिहासिक कथा | गडकोट',
    seoDescription:
      'भारताच्या ऐतिहासिक गडांबद्दल, मंदिरांबद्दल आणि सांस्कृतिक वारसाबद्दल कथा वाचा आणि सामायिक करा.',
  },
  fortDetail: {
    heritageBadge: 'सह्याद्री • गड • वारसा',
    addFavorite: 'आवडीत जोडा',
    removeFavorite: 'आवडीतून काढा',
    about: 'या गडांबद्दल',
    keyInformation: 'मुख्य माहिती',
    visitingHours: 'भेट देण्याची वेळ',
    audioGuideAvailable: 'ऑडिओ मार्गदर्शक उपलब्ध',
    audioGuideDescription: 'या गडाच्या इतिहासाच्या आणि गोष्टींचे ऐका',
    startAudioGuide: 'ऑडिओ मार्गदर्शक सुरू करा',
    backToForts: 'सर्व गडांकडे',
    notFound: 'गड सापडला नाही',
    quickInfo: 'त्वरित माहिती',
    location: 'स्थान',
    builtIn: 'बांधले',
    elevation: 'उंची',
    bestTimeToVisit: 'भेट देण्याचा सर्वोत्तम वेळ',
    share: 'शेअर करा',
    audioGuide: 'ऑडिओ मार्गदर्शक',
    signInForFavorites: 'आवडीत जोडण्यासाठी कृपया साइन इन करा.',
    noKeyFeatures: 'या गडासाठी अद्याप मुख्य वैशिष्ट्ये नोंदवलेली नाहीत. प्रवेश माहितीसाठी वरील वर्णन पहा.',
    historicalTimeline: 'ऐतिहासिक कालरेखा',
    virtualTour: 'आभासी सैर',
    virtualTour360: '३६०° आभासी सैर',
    virtualTour360Short: '३६०° सैर',
    videoDocumentary: 'व्हिडिओ माहितीपट',
    architectureDetails: 'वास्तुकला तपशील',
    storiesLegends: 'कथा आणि दंतकथा',
    richMedia: 'मिडिया अनुभव',
    navLocationFeatures: 'नेव्हिगेशन आणि स्थान वैशिष्ट्ये',
    gpsNavigation: 'GPS मार्गदर्शन',
    arView: 'AR दृश्य',
    offlineMaps: 'ऑफलाइन नकाशे',
    nearbyPlaces: 'जवळची ठिकाणे',
    multimediaExperiences: 'मल्टिमिडिया अनुभव',
    audioGuides: 'ऑडिओ मार्गदर्शक',
    audioGuidesTitle: 'बहुभाषिक ऑडिओ मार्गदर्शक',
    qrScanner: 'QR स्कॅनर',
    reenactments: 'ऐतिहासिक पुनर्निर्मिती',
    communitySocialFeatures: 'समुदाय आणि सामाजिक वैशिष्ट्ये',
    photoCommunity: 'फोटो समुदाय',
    reviews: 'पुनरावलोकने',
    reviewsTitle: 'पुनरावलोकने आणि गुण',
    checkIn: 'चेक-इन',
    checkInTitle: 'चेक-इन प्रणाली',
    socialShare: 'सामाजिक शेअर',
    socialShareTitle: 'सामाजिक समाकलन',
    myProfile: 'माझे प्रोफाइल',
    arViewTitle: 'AR ऐतिहासिक दृश्य',
    qrScannerTitle: 'QR कोड स्कॅनर',
  },
  fortMedia: {
    close: 'बंद करा',
    loadingScene: 'दृश्य लोड होत आहे...',
    dragToRotate: 'फिरवण्यासाठी ड्रॅग करा',
    panHint: 'पाहण्यासाठी ड्रॅग करा किंवा स्क्रोल करा',
    audioNarration: 'ऑडिओ वर्णन',
    loadingDocumentary: 'माहितीपट लोड होत आहे...',
    chapters: 'प्रकरणे',
    documentarySeries: 'माहितीपट मालिका',
    videoUnsupported: 'आपला ब्राउझर व्हिडिओ समर्थन करत नाही.',
    architectureTitle: 'वास्तुकला तपशील',
    view3d: '३डी दृश्य',
    viewBlueprint: 'रेखाट',
    viewTechnique: 'बांधकाम पद्धत',
    model3d: '३डी मॉडेल',
    controls3d: '३डी नियंत्रण',
    autoRotate: 'स्वयं फिरवा',
    stopRotation: 'फिरवणे थांबवा',
    keyFeatures: 'मुख्य वैशिष्ट्ये',
    dimensions: 'मोजमाप',
    sections: 'विभाग',
    blueprintView: 'रेखाट दृश्य',
    blueprintHint: 'संवादात्मक रेखाट येथे दिसेल',
    constructionMethod: 'बांधकाम पद्धत',
    materials: 'साहित्य',
    tools: 'साधने',
    timeline: 'कालावधी',
    constructionProcess: 'बांधकाम प्रक्रिया',
    processFoundation: 'पाया खोदणे आणि तयारी',
    processStone: 'दगड कापणे आणि आकार',
    processWall: 'भिंत बांधकाम आणि बळकटी',
    processRoof: 'छत आणि अंतिम सजावट',
    storiesTitle: 'कथा आणि दंतकथा',
    storiesSubtitle: 'ऐतिहासिक कथा',
    storiesCount: 'कथा',
    storyDetails: 'कथेचा तपशील',
    category: 'वर्ग',
    timePeriod: 'कालखंड',
    totalDuration: 'एकूण कालावधी',
    minutes: 'मिनिटे',
    relatedStories: 'संबंधित कथा',
    characters: 'पात्रे',
    moralTitle: 'कथेचा नैतिक',
    previous: 'मागील',
    next: 'पुढील',
    playAudio: 'ऑडिओ चालू करा',
    pauseAudio: 'ऑडिओ थांबवा',
    play: 'चालू',
    pause: 'थांबवा',
    tour360Title: '३६०° आभासी सैर',
    loadingScene360: 'दृश्य लोड होत आहे...',
    autoRotating: 'स्वयं फिरत आहे',
    learnMore: 'अधिक जाणून घ्या',
    tourInfo: 'सैर माहिती',
    progress: 'प्रगती',
    timeSpent: 'वेळ',
    scenes: 'दृश्ये',
    quality: 'गुणवत्ता',
    viewMode: 'दृश्य मोड',
    startGuidedTour: 'मार्गदर्शित सैर सुरू करा',
    tourMap: 'सैर नकाशा',
    interactiveMap: 'संवादात्मक नकाशा',
    qualityLow: 'कमी',
    qualityMedium: 'मध्यम',
    qualityHigh: 'उच्च',
    quality4k: '४के',
    dimWidth: 'रुंदी',
    dimHeight: 'उंची',
    dimDepth: 'खोली',
    dimPerimeter: 'परिघ',
    dimArea: 'क्षेत्रफळ',
  },
  timeline: {
    close: 'बंद करा',
    selectEvent: 'तपशील पाहण्यासाठी घटनेवर क्लिक करा',
    year: 'वर्ष',
    impact: 'परिणाम',
    moreDetails: 'अधिक माहिती',
    eraOf: 'युग',
    eventsCount: 'घटना',
    navPrev: 'मागील युग',
    navNext: 'पुढील युग',
    defaultSubtitle: 'मराठा साम्राज्याच्या उंची-नीचींचा प्रवास',
    raigadSubtitle: 'छत्रपती शिवाजी महाराजांच्या राजधानीचा प्रवास',
    rangeDefault: '१६०० – १८१८',
    rangeRaigad: '१६४७ – आज',
  },
  wades: {
    title: 'वाडे',
    subtitle: 'महाराष्ट्रातील ऐतिहासिक वाडे, हवेली आणि सांस्कृतिक वारसा',
    heritageBadge: 'मराठी वारसा • वाडे',
    intro:
      'वाडे हे महाराष्ट्राच्या सामाजिक, राजकीय आणि सांस्कृतिक इतिहासाचे जिवंत साक्षीदार आहेत. खाली महाराष्ट्रातील प्रसिद्ध वाडे, हवेली आणि ऐतिहासिक निवास — संपूर्ण माहिती, वैशिष्ट्ये आणि भेटीसाठी योग्य काळ.',
    loading: 'वाडे लोड होत आहेत…',
    loadError: 'वाडे लोड होऊ शकले नाहीत',
    noWadas: 'सध्या वाडे उपलब्ध नाहीत',
    wadasFound: 'वाडे सापडली',
    searchPlaceholder: 'वाडा, जिल्हा, ठिकाण शोधा…',
    allDistricts: 'सर्व जिल्हे',
    bestTime: 'भेटीसाठी योग्य काळ',
    seoTitle: 'वाडे — ऐतिहासिक वारसा | गडकोट',
    seoDescription:
      'महाराष्ट्रातील प्रसिद्ध वाडे, हवेली आणि ऐतिहासिक निवास — शनिवार वाडा, नाना वाडा, लाल महाल, विश्रामबाग वाडा आणि अधिक.',
  },
  history: {
    title: 'इतिहास',
    subtitle: 'महाराष्ट्राच्या गड, साम्राज्य आणि सांस्कृतिक वारशाची कालखंड',
    heritageBadge: 'वारसा ग्रंथ • इतिहास',
    intro:
      'निवडक ऐतिहासिक लेख — एकच लेख किंवा विभागवार मालिका: राजवंश, युद्धे, गड आणि समाजाचा इतिहास.',
    searchPlaceholder: 'इतिहास, कालखंड किंवा विषय शोधा…',
    loading: 'ऐतिहासिक लेख लोड होत आहेत…',
    loadError: 'ऐतिहासिक माहिती लोड होऊ शकली नाही. पुन्हा प्रयत्न करा.',
    noArticles: 'लेख सापडले नाहीत',
    tryDifferentSearch: 'वेगळा शोध किंवा श्रेणी वापरून पहा',
    featured: 'वैशिष्ट्यीकृत',
    partsCount: '{{count}} भाग',
    readMore: 'लेख वाचा',
    readSeries: 'मालिका वाचा',
    backToList: 'इतिहासाकडे परत',
    partLabel: 'भाग {{number}} / {{total}}',
    partShort: 'भाग {{number}}',
    previousPart: 'मागील भाग',
    nextPart: 'पुढील भाग',
    seoTitle: 'इतिहास — वारसा ग्रंथ | गडकोट',
    seoDescription:
      'मराठा स्वराज्य, सह्याद्री गड, युद्धे आणि महाराष्ट्राच्या सांस्कृतिक वारशाबद्दल ऐतिहासिक माहिती.',
    categories: {
      all: 'सर्व',
      'maratha-empire': 'मराठा साम्राज्य',
      'forts-history': 'गडांचा इतिहास',
      battles: 'युद्धे',
      culture: 'संस्कृती आणि समाज',
      dynasties: 'राजवंश',
      general: 'सामान्य',
    },
    tithiCalendarLink: 'तिथीनुसार वर्षभराचा इतिहास (गुढी पाडवा → रंगपंचमी)',
    compendiumLink: 'संपूर्ण इतिहास संग्रह (गड, सरदार, नकाशा)',
    indiaMapLink: 'भारत ऐतिहासिक नकाशा — गड, युद्ध, मंदिर',
    heritageHubLink: 'वारसा केंद्र — भक्त गडकोट, सरदार, ठिकाण',
  },
  tithiCalendar: {
    badge: 'तिथी कॅलेंडर • इतिहास',
    title: 'तिथीनुसार वर्षभराचा इतिहास',
    subtitle:
      'गुढी पाडव्यापासून रंगपंचमीपर्यंत — प्रत्येक महिना, पक्ष आणि तिथीवर सण व ऐतिहासिक घटना. शिवकाल, पेशवाई आणि ब्रिटिश काळ — तीन टप्प्यांत.',
    seoTitle: 'तिथी कॅलेंडर — शिवकालीन इतिहास | गडकोट',
    seoDescription:
      'हिंदू तिथीनुसार मराठा इतिहास: रामनवमी — लालमहाल छापा, गुरु पौर्णिमा — पावनखिंड, सिंहगड — तानाजी आणि अनेक सण व घटना.',
    phase: 'टप्पा {{n}}',
    phasePending: '{{era}} — हा टप्पा लवकरच जोडला जाईल. सध्या शिवकालीन मॅप पूर्ण आहे.',
    loadError: 'तिथी कॅलेंडर लोड होऊ शकला नाही.',
    kindSan: 'सण',
    kindItihas: 'इतिहास',
    kindBoth: 'सण + इतिहास',
    stats: {
      events: 'एकूण घटना',
      festivals: 'सण',
      history: 'ऐतिहासिक',
      tithis: 'तिथी (घटनांसह)',
    },
    footerNote: 'प्रशासक पॅनेलमधून नवीन घटना जोडता येतात.',
    backHistory: 'इतिहासाकडे परत',
    compendiumLink: 'संपूर्ण इतिहास संग्रह',
    kindInfo: 'पंचांग माहिती',
    showPanchang: 'पंचांग माहिती दाखवा',
    noEventsTitle: 'घटना नोंद सापडल्या नाहीत',
    noEventsHint:
      'डेटाबेसमध्ये अद्याप शिवकालीन घटना जोडलेल्या नाहीत. MySQL वर scripts/mysql_tithi_history_all_in_one.sql चालवा किंवा backend पुन्हा सुरू करा (auto-seed). नंतर गुढी पाडवा, राज्याभिषेक, सिंहगड इ. तिथीवर दिसतील.',
    onMap: 'नकाशावर',
    mapSection: 'ऐतिहासिक ठिकाण — नकाशा',
    mapSectionHint: 'या घटनेशी संबंधित गड किंवा ऐतिहासिक स्थळ नकाशावर.',
    viewMap: 'नकाशा दृश्य',
    viewScroll: 'स्क्रॉल दृश्य',
    mapYearLabel: 'हिंदू वर्ष — तिथी नकाशा',
    mapHint: 'पक्ष व घटना पाहण्यासाठी महिन्याच्या प्रदेशावर टॅप करा.',
    mapSelectMonth: 'तिथी मार्ग पाहण्यासाठी वरच्या नकाशावरून महिना निवडा.',
    mapTithiShort: 'तिथी',
    mapLegendEvents: 'घटना नोंद',
    mapLegendInfo: 'पंचांग माहिती',
    mapLegendEmpty: 'नोंद नाही',
    mapLegendToday: 'आजची तिथी',
    mapTodayBadge: 'आज',
    mapTodayMonth: 'आजचा महिना',
  },
  indiaHistoricMap: {
    badge: 'संवादात्मक नकाशा • वारसा',
    title: 'भारत ऐतिहासिक नकाशा',
    subtitle:
      'भारतभर गड, युद्धभूमी, मंदिर, राजवाडे आणि ऐतिहासिक घटना — नकाशा केवळ भारतावर केंद्रित; कोणत्याही चिन्हावर क्लिक करून संपूर्ण माहिती पहा.',
    seoTitle: 'भारत ऐतिहासिक नकाशा — गड, युद्ध, मंदिर | गडकोट',
    seoDescription:
      'भारतातील गड, युद्धस्थळ, मंदिर आणि ऐतिहासिक ठिकाणे — संवादात्मक नकाशावर, तपशील पानांशी जोडलेले.',
    backHistory: 'इतिहासाकडे परत',
    searchPlaceholder: 'गड, मंदिर, युद्ध, ठिकाण शोधा…',
    loadError: 'नकाशा डेटा लोड होऊ शकला नाही.',
    noResults: 'फिल्टरनुसार ठिकाण सापडले नाही. दुसरी थर किंवा शोध वापरा.',
    mapHint: 'चिन्ह किंवा यादीतील ठिकाणावर क्लिक करा. संपूर्ण इतिहासासाठी तपशील पान उघडा.',
    listTitle: 'नकाशावरील ठिकाणे',
    placesOnMap: 'ठिकाणे',
    viewDetail: 'तपशील पहा',
    legend: 'सूची',
    mapLabel: 'उपखंड नकाशा',
    mapTitle: 'ऐतिहासिक भारत',
    indiaOnlyHint: 'फक्त भारताच्या सीमेत नकाशा हलवा व झूम करा — उपखंडातील वारसा ठिकाणे.',
    categories: {
      fort: 'गड',
      temple: 'मंदिर',
      battlefield: 'युद्धस्थळ',
      palace: 'राजवाडा',
      historic: 'ऐतिहासिक ठिकाण',
      event: 'ऐतिहासिक घटना',
    },
  },
  tithiCompendium: {
    badge: 'संपूर्ण संग्रह • इतिहास',
    title: 'तिथी इतिहास — संपूर्ण संग्रह',
    subtitle: 'दिवस-दिवसाच्या व्यतिरिक्त सर्व घटना, गड, सरदार आणि नकाशावरील ठिकाणे — एकाच ठिकाणी.',
    seoTitle: 'तिथी इतिहास संग्रह | गडकोट',
    seoDescription: 'शिवकाल, पेशवाई, ब्रिटिश काळ — सर्व ऐतिहासिक घटना, गड आणि सरदारांची संपूर्ण माहिती नकाशासह.',
    backCalendar: 'तिथी कॅलेंडराकडे परत',
    searchPlaceholder: 'घटना, गड, सरदार, ठिकाण शोधा…',
    viewList: 'यादी',
    viewMap: 'नकाशा',
    loadError: 'संग्रह लोड होऊ शकला नाही.',
    noResults: 'निकाल सापडले नाहीत.',
    mapHint: 'नकाशावरील चिन्हावर क्लिक करून गड किंवा घटना पहा.',
    stats: {
      events: 'घटना',
      forts: 'गड',
      places: 'नकाशावर',
    },
  },
  heritage: {
    backHub: 'वारसा केंद्राकडे परत',
    hub: {
      badge: 'महाराष्ट्र वारसा • गडकोट',
      title: 'वारसा केंद्र',
      subtitle:
        'भक्त गडकोट, सरदार, ऐतिहासिक ठिकाणे, भागीदार आणि भेट नियोजन — ट्रेकपेक्षा वेगळा, सखोल अनुभव.',
      seoTitle: 'वारसा केंद्र — भक्त गडकोट, सरदार, ठिकाण | गडकोट',
      seoDescription:
        'गडांवरील भक्ती मार्ग, सरदारांची चरित्रे, ऐतिहासिक स्थळे, पुस्तके व ट्रेक भागीदार, गर्दी व्यवस्थापनासाठी भेट नियोजन.',
      stats: {
        sardars: 'सरदार',
        places: 'ठिकाणे',
        bhakti: 'भक्त मार्गदर्शक',
        partners: 'भागीदार',
        visit: 'भेट नियोजन',
      },
    },
    modules: {
      gallery: {
        title: 'वारसा चित्रगॅलरी',
        desc: 'गड, मंदिर, वाडे, शस्त्रे, संस्था आणि समुदाय ट्रेकमधील फोटो.',
      },
      indiaMap: {
        title: 'भारत ऐतिहासिक नकाशा',
        desc: 'गड, युद्धस्थळ, मंदिर आणि ऐतिहासिक ठिकाणे — एकाच संवादात्मक नकाशावर.',
      },
      bhakta: {
        title: 'भक्त गडकोट',
        desc: 'देवता, दर्शन, पूजा, सण — ट्रेक माहितीपेक्षा सविस्तर भक्ती अनुभव.',
      },
      sardars: {
        title: 'सरदार',
        desc: 'छत्रपती, सेनापती, वीर — चरित्र, कृती आणि संबंधित गड.',
      },
      places: {
        title: 'ऐतिहासिक ठिकाण',
        desc: 'गड, रणभूमी, राजवाडे — स्वतंत्र कार्यक्षेत्र म्हणून.',
      },
      partners: {
        title: 'भागीदार',
        desc: 'पुस्तके, ट्रेक संस्था, पर्यटन — संबंधित विभागात फिचर.',
      },
      books: {
        title: 'वारसा पुस्तके',
        desc: 'मोफत PDF — गड इतिहास, मार्गदर्शिका, तिथी आणि भक्ती ग्रंथ.',
      },
      visit: {
        title: 'भेट नियोजन',
        desc: 'क्षमता, स्लॉट, पार्किंग — गर्दी व वाहतूक व्यवस्थापन.',
      },
    },
    gallery: {
      badge: 'महाराष्ट्र वारसा • चित्रे',
      title: 'वारसा चित्रगॅलरी',
      subtitle:
        'गड, मंदिर, वाडे, शस्त्रे, वारसा संस्था आणि मंजूर समुदाय योगदानातील चित्रे एकाच ठिकाणी.',
      seoTitle: 'वारसा चित्रगॅलरी — गड, मंदिर आणि समुदाय फोटो | गडकोट',
      seoDescription:
        'महाराष्ट्र वारसा चित्रे: गड, देवस्थाने, ऐतिहासिक वाडे, शस्त्रे, संस्था गॅलरी आणि ट्रेकर योगदान.',
      loading: 'गॅलरी लोड होत आहे…',
      loadingMore: 'अजून चित्रे लोड होत आहेत…',
      loadError: 'चित्रे लोड होऊ शकली नाहीत.',
      empty: 'या फिल्टरनुसार चित्रे सापडली नाहीत.',
      searchPlaceholder: 'ठिकाण, मथळा शोधा…',
      resultsCount: '{{count}} चित्रे',
      loadMore: 'अजून लोड करा',
      contributeCta: 'तुमचे ट्रेक फोटो शेअर करा',
      viewSource: 'मूळ पृष्ठ पहा',
      filters: {
        all: 'सर्व',
      },
      types: {
        FORT: 'गड',
        TEMPLE: 'मंदिर',
        WADA: 'वाडा',
        WEAPON: 'शस्त्र',
        ORGANIZATION: 'संस्था',
        COMMUNITY: 'समुदाय',
      },
    },
    bhakta: {
      title: 'भक्त गडकोट',
      intro:
        'गडावरची आध्यात्मिक दृष्टी — देवता, दर्शन वेळ, पूजाविधी, सण, यात्रा शिष्टाचार. ट्रेकक्षेत्रसारखी नसून भक्तांसाठी वेगळी, सखोल माहिती.',
      seoTitle: 'भक्त गडकोट — गडावरील भक्ती मार्ग | गडकोट',
      seoDescription: 'महाराष्ट्रातील गडांवरील देवता, दर्शन, पूजा, सण आणि भक्ती मार्ग — ट्रेकपेक्षा वेगळा अनुभव.',
      empty: 'सध्या भक्त मार्गदर्शक उपलब्ध नाहीत. लवकरच जोडले जातील.',
      vsTrekNote: 'ट्रेक माहिती (मार्ग, अंतर, सुरक्षा) वेगळ्या विभागात — इथे फक्त भक्ती व आध्यात्मिक माहिती.',
      panelTitle: 'भक्त गडकोट — भक्ती मार्ग',
      panelEmpty: 'या गडासाठी अजून भक्ती मार्गदर्शक जोडलेले नाही.',
      exploreAll: 'सर्व भक्त गड पहा',
      deities: 'देवता',
      significance: 'आध्यात्मिक महत्त्व',
      timings: 'दर्शन वेळ',
      puja: 'पूजाविधी',
      festivals: 'सण व उत्सव',
      etiquette: 'यात्रा शिष्टाचार',
      offerings: 'अर्पण',
      legends: 'कथा व दंतकथा',
      routes: 'भक्ती मार्ग',
    },
    sardars: {
      title: 'सरदार',
      intro: 'शिवकाल, पेशवाई व नंतरच्या काळातील वीर व्यक्तिमत्त्वे — चरित्र, युद्ध तपशील, गाव, कुळ आणि संबंधित गड.',
      seoTitle: 'सरदार — मराठा वीर | गडकोट',
      seoDescription: 'छत्रपती शिवाजी महाराज, तानाजी, बाजीप्रसाद आणि इतर सरदार — संपूर्ण ऐतिहासिक प्रोफाइल.',
      back: 'सरदार यादी',
      biography: 'चरित्र',
      deeds: 'प्रमुख कृती',
      forts: 'संबंधित गड',
      places: 'संबंधित ऐतिहासिक ठिकाण',
      warDetails: 'युद्ध तपशील',
      battles: 'प्रमुख युद्ध व मोहिमा',
      weapons: 'शस्त्रास्त्र',
      allies: 'सहकारी व सहकाऱ्य',
      enemies: 'शत्रू व विरोधक',
      memorial: 'स्मारक व समाधी',
      honors: 'सन्मान व उपाधी',
      legacy: 'ऐतिहासिक वारसा',
      sources: 'स्रोत व संदर्भ',
      village: 'मूळ गाव',
      district: 'जिल्हा',
      clan: 'कुळ / घराणे',
      lifespan: 'आयुष्य',
      deathPlace: 'मृत्यू स्थळ',
      eraAll: 'सर्व काल',
      eraShiv: 'शिवकाल',
      eraPeshwa: 'पेशवाई',
      eraBritish: 'ब्रिटिश काल',
      empty: 'या कालखंडासाठी सरदार सापडले नाहीत.',
      count: '{count} सरदार',
      viewProfile: 'संपूर्ण प्रोफाइल पहा',
    },
    places: {
      title: 'ऐतिहासिक ठिकाण',
      intro: 'गड, रणभूमी, राजवाडे — प्रत्येक ठिकाण स्वतंत्र कार्यक्षेत्र म्हणून.',
      seoTitle: 'ऐतिहासिक ठिकाण | गडकोट',
      seoDescription: 'रायगड, पावनखिंड, लालमहाल, प्रतापगड, सिंहगड — ऐतिहासिक स्थळांची माहिती.',
      back: 'ठिकाण यादी',
      viewFort: 'गड पृष्ठ पहा',
    },
    partners: {
      title: 'भागीदार',
      intro: 'या क्षेत्रातील पुस्तके, ट्रेक संस्था, पर्यटन — संबंधित विभागात फिचर.',
      website: 'संकेतस्थळ',
    },
    visit: {
      title: 'भेट नियोजन',
      hubTitle: 'भेट नियोजन व गर्दी व्यवस्थापन',
      hubIntro:
        'पावसाळा, नवरात्री, दिवाळी — सोप्या प्रवेशासाठीही गर्दी होते. क्षमता, स्लॉट, पार्किंग व प्रवेशद्वार योजना.',
      seoTitle: 'भेट नियोजन — नोंदणी व क्षमता | गडकोट',
      seoDescription: 'गर्दी व्यवस्थापन, दैनिक क्षमता, स्लॉट, पार्किंग — MTDC सहकार्यासाठी तयार.',
      tourismVision:
        'दीर्घकालीन: नोंदणी, पास, स्लॉट व वाहतूक व्यवस्थापन — महाराष्ट्र पर्यटन प्रस्तावासाठी.',
      registrationRequired: 'नोंदणी / स्लॉट आवश्यक',
      dailyCap: 'दैनिक क्षमता',
      slotCap: 'प्रति स्लॉट',
      parking: 'पार्किंग',
      peak: 'गर्दीचा काळ',
      entry: 'प्रवेशद्वार',
    },
    booking: {
      title: 'गड भेट — तिकीट बुक करा',
      intro: 'गर्दी व्यवस्थापनासाठी वेळ-स्लॉट निवडून तिकीट बुक करा. पुष्टी कोड ईमेल/मोबाइलवर ठेवा.',
      date: 'भेट दिनांक',
      slot: 'वेळ स्लॉट',
      selectSlot: 'वेळ स्लॉट निवडा',
      visitors: 'अभ्यागत संख्या',
      name: 'नाव',
      email: 'ईमेल',
      phone: 'मोबाइल',
      submit: 'तिकीट बुक करा',
      confirmed: 'तिकीट बुक झाले!',
      confirmedHint: 'खालील पुष्टी कोड गडावर दाखवा. स्क्रीनशॉट ठेवा.',
      confirmationCode: 'पुष्टी कोड',
      fort: 'गड',
      bookAnother: 'आणखी एक तिकीट बुक करा',
      dailyRemaining: 'उर्वरित दैनिक जागा',
      noSlots: 'या दिवशी स्लॉट उपलब्ध नाहीत. दुसरा दिनांक निवडा.',
      loadSlotsError: 'स्लॉट लोड होऊ शकले नाहीत.',
      bookError: 'बुकिंग अयशस्वी. कृपया पुन्हा प्रयत्न करा.',
      bookOnFort: 'गड पृष्ठावर तिकीट बुक करा',
      passTitle: 'प्रवेश पास',
      qrHint: 'गडावर हा QR स्कॅन करा',
      printPass: 'पास प्रिंट / सेव्ह',
      free: 'मोफत',
      amount: 'रक्कम',
      emailSent: 'ईमेल पाठवले',
      smsSent: 'SMS पाठवले',
      ticketPrice: 'तिकीट दर',
      perPerson: 'प्रति व्यक्ती',
      estimatedTotal: 'अंदाजे एकूण',
      submitPaid: 'पेमेंट करून बुक करा',
      paymentPending: 'पेमेंट बाकी',
      paymentPendingHint: 'कोड {{code}} — रक्कम {{amount}}. पेमेंट पूर्ण करा.',
      payNow: 'आता पेमेंट करा',
      demoPay: 'डेमो पेमेंट (Dev)',
      paymentError: 'पेमेंट अयशस्वी',
      paymentCancelled: 'पेमेंट रद्द',
      lookupTitle: 'तिकीट शोधा',
      lookupIntro: 'पुष्टी कोड टाकून QR पास पहा.',
      lookupBtn: 'शोधा',
      notFound: 'बुकिंग सापडली नाही',
      pendingOnLookup: 'पेमेंट बाकी — गड पृष्ठावरून पेमेंट पूर्ण करा.',
      cancelledOnLookup: 'हे बुकिंग रद्द झाले आहे.',
    },
  },
  footer: {
    location: 'मुंबई, महाराष्ट्र',
  },
  shop: {
    title: 'वारसा दुकान',
    badge: 'अधिकृत गडकोट स्टोअर',
    heroSubtitle: 'मराठा इतिहास पुस्तके, ट्रेक साहित्य, डिजिटल मार्गदर्शक आणि वारसा मर्च — संपूर्ण भारतात पोहोच.',
    seoTitle: 'वारसा दुकान | गडकोट',
    seoDescription: 'वारसा पुस्तके, ट्रेक साहित्य, डिजिटल गड मार्गदर्शक आणि गडकोट मर्च खरेदी करा.',
    searchPlaceholder: 'उत्पादने शोधा…',
    categories: {
      all: 'सर्व',
      books: 'पुस्तके',
      trekGear: 'ट्रेक साहित्य',
      digital: 'डिजिटल',
      merch: 'मर्च',
    },
    addToCart: 'कार्टमध्ये जोडा',
    inStock: 'स्टॉक उपलब्ध',
    outOfStock: 'स्टॉक संपला',
    cartTitle: 'कार्ट',
    cartEmpty: 'तुमची कार्ट रिकामी आहे.',
    remove: 'काढा',
    total: 'एकूण',
    checkout: 'चेकआउट',
    backToShop: 'दुकानाकडे परत',
    loadError: 'उत्पादने लोड होऊ शकली नाहीत.',
    noProducts: 'उत्पादने सापडली नाहीत.',
    checkoutTitle: 'चेकआउट',
    orderSummary: 'ऑर्डर सारांश',
    name: 'पूर्ण नाव',
    email: 'ईमेल',
    addressEmailHint: 'या ईमेलशी संबंधित आधीचा पत्ता असल्यास तो सुरक्षितपणे भरला जाईल.',
    previousAddresses: 'मागील पत्त्यांमधून निवडा',
    loadingAddresses: 'मागील पत्ते शोधत आहे…',
    phone: 'मोबाइल',
    address: 'पोहोच पत्ता',
    city: 'शहर',
    pincode: 'पिन कोड',
    placeOrder: 'ऑर्डर द्या आणि पेमेंट करा',
    checkoutError: 'चेकआउट अयशस्वी. कृपया पुन्हा प्रयत्न करा.',
    paymentPending: 'पेमेंट बाकी',
    paymentPendingHint: 'ऑर्डर {{code}} — {{amount}}. पुष्टीसाठी पेमेंट पूर्ण करा.',
    payNow: 'आता पेमेंट करा',
    demoPay: 'डेमो पेमेंट (Dev)',
    paymentError: 'पेमेंट अयशस्वी',
    paymentCancelled: 'पेमेंट रद्द',
    orderDescription: 'गडकोट दुकान ऑर्डर {{code}}',
    orderTitle: 'ऑर्डर तपशील',
    orderConfirmed: 'ऑर्डर पुष्टी झाली!',
    orderConfirmedHint: 'धन्यवाद! आम्ही तुमचा ऑर्डर प्रक्रिया करू आणि ईमेलवर अपडेट पाठवू.',
    orderCode: 'ऑर्डर कोड',
    status: 'स्थिती',
    statuses: {
      PENDING_PAYMENT: 'पेमेंट बाकी',
      PAID: 'पेमेंट झाले',
      CANCELLED: 'रद्द',
    },
    orderNotFound: 'ऑर्डर सापडला नाही',
    completePayment: 'पेमेंट पूर्ण करा',
    continueShopping: 'खरेदी सुरू ठेवा',
  },
  fortQa: {
    title: 'AI गड मार्गदर्शक',
    globalTitle: 'AI गड मार्गदर्शक',
    subtitle: '{{name}} बद्दल विचारा — गडकोट CMS माहितीवरून उत्तरे',
    globalSubtitle: 'कोणत्याही महाराष्ट्रातील गडाबद्दल विचारा — प्रश्नातून गड ओळखला जातो',
    globalHero: 'इतिहास, ट्रेक, दिशा, वेळ — गडकोट वारसा माहितीवरून. मराठीत लिहा किंवा बोला.',
    seoTitle: 'AI गड मार्गदर्शक | गडकोट',
    seoDescription: 'महाराष्ट्रातील गडांबद्दल मराठी/इंग्रजी Q&A — गडकोट CMS माहितीवरून.',
    thisFort: 'हा गड',
    cmsBadge: 'CMS-आधारित',
    placeholder: 'मराठी किंवा इंग्रजीत विचारा…',
    send: 'पाठवा',
    thinking: 'गडकोट माहिती शोधत आहे…',
    emptyHint: 'सुचवलेला प्रश्न निवडा किंवा इतिहास, ट्रेक, दिशा याबद्दल विचारा.',
    globalEmptyHint: 'प्रश्नात गडाचे नाव सांगा, उदा. \"रायगड कसा जायचा?\" किंवा माइक वापरा.',
    error: 'उत्तर मिळाले नाही. कृपया पुन्हा प्रयत्न करा.',
    aiPowered: 'AI उत्तर',
    aiError: 'AI समस्या',
    disclaimer: 'उत्तरे गडकोट गड, ट्रेक आणि वारसा माहितीवरून. प्रवासापूर्वी महत्त्वाची माहिती पुन्हा तपासा.',
    viewFort: '{{name}} पहा',
    voiceStart: 'प्रश्न बोला',
    voiceStop: 'ऐकणे थांबवा',
    voiceDenied: 'मायक्रोफोन परवानगी नाही. ब्राउझरमध्ये mic परवानगी द्या.',
    voiceError: 'व्हॉइस इनपुट अयशस्वी. टाइप करून विचारा.',
    voiceUnsupported: 'Chrome/Edge (Desktop/Android) वर व्हॉइस इनपुट चालते.',
    listening: 'ऐकत आहे',
    sources: {
      fort: 'गड माहिती',
      trekGuide: 'ट्रेक मार्गदर्शक',
      bhaktiGuide: 'भक्ती मार्गदर्शक',
      practicalInfo: 'प्रात्यक्षिक माहिती',
      unknown: 'CMS',
    },
  },
  pwa: {
    install: 'अॅप इन्स्टॉल करा',
    installHint: 'ट्रेकवर ऑफलाइन चेकलिस्ट आणि नकाशे — गडकोट इन्स्टॉल करा.',
    offline: {
      title: 'ऑफलाइन ट्रेक पॅक',
      subtitle: 'सिग्नल जाण्यापूर्वी गड मार्गदर्शक, आपत्कालीन संपर्क आणि नकाशे डाउनलोड करा.',
      online: 'ऑनलाइन',
      offline: 'ऑफलाइन',
      cached: 'ऑफलाइन — जतन केलेली यादी',
      checklistEmpty: 'चेकलिस्ट अद्याप जतन नाही. ऑनलाइन असताना एकदा हा टॅब उघडा.',
      storage: 'स्टोरेज: {{used}} MB / {{total}} MB',
      downloadFort: 'गड पॅक + नकाशा डाउनलोड',
      downloading: 'डाउनलोड होत आहे',
      needOnline: 'नवीन पॅक डाउनलोड करण्यासाठी इंटरनेट कनेक्ट करा.',
      downloadError: 'डाउनलोड अयशस्वी. ऑनलाइन असताना पुन्हा प्रयत्न करा.',
      empty: 'अद्याप ऑफलाइन पॅक नाहीत. वर गड निवडून डाउनलोड करा.',
      tilesSaved: '{{count}} नकाशा टाइल्स जतन',
      packOnly: 'मार्गदर्शक जतन — नकाशा टाइल्स प्रलंबित',
    },
  },
  community: {
    badge: 'समुदाय व वाढ',
    title: 'गडकोट समुदाय',
    hero: 'वारसा सामग्री विका, सशुल्क ट्रेक, बक्षिसे, मित्रांना आमंत्रित करा, WhatsApp स्मरणपत्र.',
    seoTitle: 'समुदाय — निर्माते, बक्षिसे | Gadkot',
    seoDescription: 'Creator marketplace, सशुल्क कार्यक्रम, contribution बक्षिसे, referral आणि WhatsApp अलर्ट.',
    error: 'काहीतरी चूक झाली. पुन्हा प्रयत्न करा.',
    tabs: {
      creators: 'निर्माते',
      marketplace: 'सशुल्क कार्यक्रम',
      rewards: 'बक्षिसे',
      referral: 'मित्रांना आमंत्रित करा',
      alerts: 'WhatsApp',
    },
    creators: {
      subtitle: 'छायाचित्रकार आणि इतिहासकार मुद्रण, मार्गदर्शक, संशोधन विकतात — Gadkot review.',
      applyTitle: 'Creator program साठी अर्ज',
      name: 'तुमचे नाव',
      role: 'पद (उदा. Photographer)',
      listingTitle: 'Listing शीर्षक',
      description: 'वर्णन',
      fort: 'संबंधित गड',
      priceInr: 'किंमत (₹, ऐच्छिक)',
      submit: 'Review साठी पाठवा',
      submitted: 'पाठवले — आम्ही review करू.',
      buy: 'पहा / खरेदी',
      myCount: 'तुम्ही {{count}} listing सादर केले',
      empty: 'अद्याप कोणतीही creator listing नाही.',
      emptyDesc: 'छायाचित्रकार, इतिहासकार किंवा मार्गदर्शक असाल तर खाली अर्ज करा — पहिले listing तुमचे असू शकते.',
      applyCta: 'Creator program साठी अर्ज करा',
      types: { PHOTO: 'छाया', ARTICLE: 'लेख', GUIDE: 'मार्गदर्शक', RESEARCH: 'संशोधन' },
    },
    marketplace: {
      subtitle: 'ट्रेक गट आणि संस्था Gadkot calendar वर सशुल्क कार्यक्रम listing करतात.',
      viewCalendar: 'कार्यक्रम calendar उघडा',
      empty: 'अद्याप सशुल्क कार्यक्रम नाहीत.',
      register: 'नोंदणी / पेमेंट',
      paidEvent: 'सशुल्क कार्यक्रम (marketplace)',
      priceInr: 'तिकीट किंमत (₹)',
      registrationUrl: 'नोंदणी किंवा payment link',
      maxSeats: 'जास्तीत जागा',
      paidFrom: '₹{{price}} पासून',
    },
    rewards: {
      signIn: 'बक्षिसे पाहण्यासाठी sign in करा.',
      balance: 'तुमचे गुण',
      shopCredit: 'shop सवलत',
      redeemShop: 'Shop checkout वर redeem करा',
      earnContribution: 'contribution मंजूर → +{{pts}}',
      earnReview: 'पहिला fort review → +{{pts}}',
      earnReferral: 'मित्र join → +{{pts}}',
      history: 'अलीकडील activity',
      usePoints: 'Reward points वापरा (शिलक: {{balance}})',
    },
    referral: {
      subtitle: 'मित्रांना Gadkot वर महाराष्ट्र वारसा शोधायला आमंत्रित करा.',
      signIn: 'Invite link साठी sign in करा.',
      yourCode: 'तुमचा referral code',
      invites: '{{count}} मित्र join झाले',
      copyLink: 'Link कॉपी करा',
      copied: 'कॉपी झाले!',
      shareText: 'Gadkot वर सामील व्हा — गड, ट्रेक, वारसा:',
      codeOptional: 'Referral code (ऐच्छिक)',
      codePlaceholder: 'मित्राचा code',
    },
    alerts: {
      subtitle: 'WhatsApp वर event/trek स्मरणपत्र (pre-filled message).',
      signIn: 'Preferences साठी sign in करा.',
      eventReminders: 'Event reminders',
      trekUpdates: 'Trek updates',
      phone: 'WhatsApp number (ऐच्छिक)',
      save: 'जतन करा',
      saved: 'जतन झाले',
      hint: 'कोणत्याही event card वर “WhatsApp स्मरण” वापरा.',
      remindWhatsApp: 'WhatsApp स्मरण',
    },
  },
  education: {
    loadError: 'शैक्षणिक माहिती लोड झाली नाही.',
    back: 'मागे',
    minutes: 'मिनिटे',
    keyPoints: 'महत्त्वाचे मुद्दे',
    learn: {
      badge: 'वारसा अभ्यासक्रम',
      title: 'महाराष्ट्राचा वारसा शिका',
      subtitle: 'स्वराज्याचा इतिहास, दुर्ग स्थापत्य आणि परीक्षा उजळणीचे क्रमबद्ध अभ्यासक्रम.',
      overall: 'एकूण {{progress}}% प्रगती',
      lessonCount: '{{count}} धडे',
      markComplete: 'धडा पूर्ण करा',
      markIncomplete: 'अपूर्ण करा',
      seoTitle: 'वारसा अभ्यासक्रम | Gadkot',
    },
    notes: {
      title: 'परीक्षा तयारी व झटपट नोट्स',
      subtitle: 'MPSC, पर्यटन आणि वारसा विद्यार्थ्यांसाठी नेमकी एका पानाची उजळणी.',
      search: 'विषय व नोट्स शोधा…',
      all: 'सर्व विभाग',
      open: 'नोट उघडा',
      examTips: 'परीक्षा टिप्स',
      download: 'नोट्स डाउनलोड',
      print: 'प्रिंट',
      seoTitle: 'MPSC वारसा झटपट नोट्स | Gadkot',
    },
    institution: {
      title: 'शाळा व महाविद्यालय पोर्टल',
      subtitle: 'शैक्षणिक गडभेट नियोजित करा आणि वर्गासाठी वारसा कार्यपत्रिका डाउनलोड करा.',
      worksheets: 'कार्यपत्रिका',
      download: 'PDF/DOC डाउनलोड',
      worksheetHint: 'वर्गात वापरण्यासाठी छापता येणारी PDF किंवा Word कार्यपत्रिका — थेट डाउनलोड करा.',
      emptyTitle: 'अद्याप कार्यपत्रिका उपलब्ध नाहीत',
      emptyDesc: 'PDF किंवा Word फाइल अपलोड झाल्यावर कार्यपत्रिका येथे दिसतील.',
      bookTitle: 'गटभेटीची विनंती',
      bookSubtitle: 'गड, तारीख, विद्यार्थी संख्या आणि अभ्यास पातळी कळवा.',
      name: 'संस्थेचे नाव',
      school: 'शाळा',
      college: 'महाविद्यालय',
      contact: 'समन्वयकाचे नाव',
      email: 'ईमेल',
      phone: 'फोन',
      fort: 'पसंतीचा गड',
      students: 'विद्यार्थ्यांची संख्या',
      grade: 'इयत्ता / अभ्यासक्रम',
      notes: 'प्रवेशयोग्यता, प्रवास किंवा अध्ययन गरजा',
      submit: 'भेटीची विनंती पाठवा',
      success: 'विनंती #{{id}} पाठवली. गडकोट टीम तुमच्याशी संपर्क करेल.',
      seoTitle: 'शाळा-महाविद्यालय वारसा भेटी | Gadkot',
    },
    audio: {
      title: 'मराठी ऑडिओबुक संग्रह',
      subtitle: 'गडकथा, लढाया, दंतकथा आणि वारसा माहिती मराठीत ऐका.',
      listen: 'ऐका',
      stop: 'थांबवा',
      chapters: 'प्रकरणे',
      recorded: 'रेकॉर्ड केलेले ऑडिओ',
      mp3Hint: 'सर्व ऑडिओबुक रेकॉर्ड केलेल्या MP3 फाइलद्वारे ऐकवले जातात — सर्व उपकरणांवर समान अनुभव.',
      emptyTitle: 'अद्याप ऑडिओबुक उपलब्ध नाहीत',
      emptyDesc: 'रेकॉर्ड केलेले MP3 अपलोड झाल्यावर ऑडिओबुक येथे दिसतील.',
      seoTitle: 'मराठी गड ऑडिओबुक | Gadkot',
    },
  },
  books: {
    title: 'वारसा पुस्तके',
    subtitle: 'महाराष्ट्रातील गड इतिहास, मार्गदर्शिका, तिथी आणि भक्ती ग्रंथ ऑनलाइन वाचा — मोफत PDF.',
    seoTitle: 'वारसा पुस्तके — मराठी गड इतिहास PDF | गडकोट',
    seoDescription: 'मोफत वारसा पुस्तके: गड मार्गदर्शिका, इतिहास, भक्ती ग्रंथ आणि गडकोट प्रकाशने.',
    searchPlaceholder: 'शीर्षक किंवा लेखकाने शोधा…',
    emptyTitle: 'अद्याप पुस्तके उपलब्ध नाहीत',
    emptyDesc: 'Admin टीम PDF प्रकाशित केल्यावर पुस्तके येथे दिसतील.',
    resultsCount: '{{count}} पुस्तके',
    readOnline: 'ऑनलाइन वाचा',
    pageCount: '{{count}} पाने',
    backToLibrary: 'पुस्तकालयाकडे परत',
    notFound: 'पुस्तक सापडले नाही.',
    downloadPdf: 'PDF डाउनलोड',
    freeToRead: 'मोफत वाचन',
    byAuthor: 'लेखक: {{author}}',
    openInNewTab: 'PDF नवीन टॅबमध्ये उघडा',
    readerHint: 'रीडर लोड न झाल्यास “PDF नवीन टॅबमध्ये उघडा” किंवा डाउनलोड वापरा.',
    filters: { all: 'सर्व' },
    categories: {
      HISTORY: 'इतिहास',
      FORT: 'गड',
      DEVOTIONAL: 'भक्ती',
      TITHI: 'तिथी व दिनदर्शिका',
      GUIDE: 'मार्गदर्शिका',
      OTHER: 'इतर',
    },
    licenses: {
      PUBLIC_DOMAIN: 'सार्वजनिक',
      GADKOT_ORIGINAL: 'गडकोट मूळ',
      PARTNER: 'भागीदार प्रकाशन',
    },
  },
  adminBooks: {
    title: 'वारसा पुस्तके',
    subtitle: '/books साठी PDF आणि कव्हर अपलोड करा.',
    refresh: 'रिफ्रेश',
    addBook: 'पुस्तक जोडा',
    editBook: 'पुस्तक संपादित करा',
    slug: 'URL slug',
    category: 'श्रेणी',
    titleEn: 'शीर्षक (इंग्रजी)',
    titleMr: 'शीर्षक (मराठी)',
    authorEn: 'लेखक (इंग्रजी)',
    authorMr: 'लेखक (मराठी)',
    descriptionEn: 'वर्णन (इंग्रजी)',
    descriptionMr: 'वर्णन (मराठी)',
    coverUrl: 'कव्हर चित्र',
    pdfUrl: 'PDF फाईल',
    pdfHint: 'PDF अपलोड करा — प्रकाशनासाठी आवश्यक.',
    language: 'भाषा',
    license: 'परवाना',
    pageCount: 'पान संख्या',
    sortOrder: 'प्रदर्शन प्राधान्य',
    isFree: 'मोफत वाचन',
    allowDownload: 'डाउनलोड परवानगी',
    active: 'प्रकाशित',
    save: 'जतन',
    cancel: 'रद्द',
    empty: 'अद्याप पुस्तके नाहीत. पहिले PDF जोडा.',
    colTitle: 'शीर्षक',
    colCategory: 'श्रेणी',
    colStatus: 'स्थिती',
    colActions: 'क्रिया',
    published: 'प्रकाशित',
    draft: 'मसुदा',
    edit: 'संपादन',
    delete: 'हटवा',
    loadError: 'पुस्तके लोड होऊ शकली नाहीत.',
    saveError: 'पुस्तक जतन होऊ शकले नाही.',
    deleteError: 'पुस्तक हटवता आले नाही.',
    confirmDelete: 'हे पुस्तक कायमचे हटवायचे?',
    errors: {
      pdfRequired: 'PDF फाईल आवश्यक आहे.',
      pdfOnly: 'फक्त PDF फाईल्स परवानगी.',
    },
  },
  mobile: {
    back: 'मागे',
    close: 'बंद',
    backHome: 'मुख्यपृष्ठावर',
    tabs: {
      label: 'मुख्य नेव्हिगेशन',
      home: 'मुख्य',
      forts: 'गड',
      trek: 'ट्रेक',
      temples: 'मंदिर',
      menu: 'मेनू',
    },
    home: {
      greeting: 'गडकोटमध्ये स्वागत',
      title: 'महाराष्ट्राचा वारसा शोधा',
      searchPlaceholder: 'गड, मंदिर, ठिकाणे शोधा…',
      quickActions: 'जलद कृती',
      featuredForts: 'ठळक गड',
      seeAll: 'सर्व पहा',
    },
    actions: {
      nearby: 'जवळचे गड',
      search: 'शोध',
      events: 'कार्यक्रम',
      heritage: 'वारसा',
    },
    settings: {
      title: 'अॅप सेटिंग्ज',
      apiTitle: 'बॅकएंड सर्व्हर',
      apiHint: 'डेटा लोड न झाल्यास API URL सेट करा. स्थानिक चाचणीसाठी PC IP वापरा (उदा. http://192.168.1.5:8080). Production: https://gadkot.com',
      apiLabel: 'API base URL',
      examples: 'उदा.: https://gadkot.com · http://192.168.1.5:8080',
      save: 'जतन',
      saved: 'जतन झाले',
      test: 'कनेक्शन तपासा',
      testOk: 'कनेक्ट झाले — forts API चालते',
      testFail: 'कनेक्ट झाले नाही. URL, Wi‑Fi आणि backend तपासा.',
      reset: 'डीफॉल्ट',
    },
  },
};
